(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tl-batch-lineup"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-batch-lineup'))customElements.define('tl-batch-lineup',class extends HTMLElement{
connectedCallback(){if(this.bound)return;this.rail=this.querySelector('[data-lineup-rail]');if(!this.rail)return;this.bound=true;this.querySelector('[data-lineup-controls]').hidden=false;this.click=e=>{const b=e.target.closest('[data-step]');if(!b)return;this.rail.scrollBy({left:this.rail.clientWidth*.8*Number(b.dataset.step),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};this.sync=()=>{const bs=this.querySelectorAll('[data-step]');bs[0].disabled=this.rail.scrollLeft<3;bs[1].disabled=this.rail.scrollLeft>=this.rail.scrollWidth-this.rail.clientWidth-3};this.addEventListener('click',this.click);this.rail.addEventListener('scroll',this.sync,{passive:true});this.resize=new ResizeObserver(this.sync);this.resize.observe(this.rail);this.sync()}
disconnectedCallback(){this.removeEventListener('click',this.click);this.rail?.removeEventListener('scroll',this.sync);this.resize?.disconnect();this.bound=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-business-hero"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('tl-business-scene')) {
    customElements.define('tl-business-scene', class extends HTMLElement {
      connectedCallback() {
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.animations = [];
        const visual = this.querySelector('.tl-business-hero__visual');
        if (!visual || !window.IntersectionObserver || !visual.animate) return;
        this.stopMotion = () => { if (this.motion.matches) this.animations.forEach(a => a.cancel()); };
        this.motion.addEventListener('change', this.stopMotion);
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          if (this.motion.matches) return;
          const end = 'translateY(0) scale(1)';
          this.animations.push(visual.animate([
            {transform: 'translateY(24px) scale(.985)', opacity: .85},
            {transform: end, opacity: 1}
          ], {duration: 700, easing: 'cubic-bezier(.16,1,.3,1)'}));
        }, {threshold: .12});
        this.observer.observe(visual);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.animations?.forEach(a => a.cancel());
        if (this.stopMotion) this.motion.removeEventListener('change', this.stopMotion);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-catalog-browser"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-catalog-browser'))customElements.define('tl-catalog-browser',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;
  this.abort=new AbortController();const signal=this.abort.signal;
  const on=(node,type,handler,options={})=>node?.addEventListener(type,handler,{...options,signal});
  const controls=this.querySelector('[data-catalog-controls]'),input=this.querySelector('[data-catalog-search]'),count=this.querySelector('[data-catalog-count]'),empty=this.querySelector('[data-catalog-empty]'),cards=[...this.querySelectorAll('[data-catalog-model]')];
  if(!controls||!input||!count||!empty)return;
  const normalize=value=>value.normalize('NFKC').toLocaleLowerCase().trim();
  const updateSearch=()=>{const query=normalize(input.value);let visible=0;cards.forEach(card=>{card.hidden=!normalize(card.dataset.search||'').includes(query);if(!card.hidden)visible++});count.textContent=String(visible);empty.hidden=visible>0};
  on(input,'input',updateSearch);on(this.querySelector('[data-catalog-reset]'),'click',()=>{input.value='';updateSearch();input.focus()});controls.hidden=false;
  const reset=this.querySelector('[data-catalog-reset]');if(reset)reset.hidden=cards.length===0;updateSearch();
  this.preference=matchMedia('(prefers-reduced-motion: reduce)');this.animations=new Set();
  const track=animation=>{this.animations.add(animation);animation.finished.catch(()=>{}).finally(()=>this.animations.delete(animation));return animation};
  const cancelMotion=()=>{this.animations.forEach(animation=>animation.cancel());this.animations.clear()};
  const dialog=this.querySelector('[data-shortlist-dialog]'),bar=this.querySelector('[data-shortlist-bar]'),view=this.querySelector('[data-shortlist-view]'),list=this.querySelector('[data-shortlist-list]'),template=this.querySelector('[data-shortlist-row]'),form=this.querySelector('[data-shortlist-form]'),inquiry=this.querySelector('[data-shortlist-inquiry]'),status=this.querySelector('[data-shortlist-status]'),hint=this.querySelector('[data-shortlist-hint]'),endView=this.querySelector('[data-shortlist-end-view]'),cardViews=[...this.querySelectorAll('[data-shortlist-card-view]')];
  this.dialog=dialog;this.selection=new Map();const selection=this.selection,records=new Map();let origin,modalAnimation,revision=0,lastToggle;
  const supported=dialog&&typeof dialog.showModal==='function'&&bar&&list&&template&&form&&inquiry&&status&&hint;
  const announce=text=>{status.textContent=text};
  const updateEntries=()=>{
   if(endView)endView.hidden=selection.size===0;
   cardViews.forEach(button=>{button.hidden=!selection.has(button.closest('[data-shortlist-key]').dataset.shortlistKey)});
   this.querySelectorAll('[data-shortlist-inline-count]').forEach(badge=>{badge.textContent=String(selection.size)});
   [endView,...cardViews].forEach(button=>button?.setAttribute('aria-label',view.textContent.trim()+'. '+this.dataset.shortlistCount.replace('__COUNT__',String(selection.size))));
  };
  const lockPage=()=>{
   if(this.pageLock)return;
   const root=document.documentElement;
   this.pageLock={overflow:root.style.overflow,gutter:root.style.scrollbarGutter,x:scrollX,y:scrollY};
   root.style.scrollbarGutter='stable';root.style.overflow='hidden';
  };
  this.unlockPage=()=>{
   if(!this.pageLock)return;
   const saved=this.pageLock;this.pageLock=null;
   document.documentElement.style.overflow=saved.overflow;document.documentElement.style.scrollbarGutter=saved.gutter;
   window.scrollTo({left:saved.x,top:saved.y,behavior:'instant'});
  };
  const updateSelection=()=>{
   records.forEach(record=>{const selected=selection.has(record.key);record.button.setAttribute('aria-pressed',String(selected));record.button.disabled=!selected&&selection.size>=3;record.button.querySelector('[data-shortlist-button-label]').textContent=selected?this.dataset.shortlistSelected:this.dataset.shortlistAdd});
   this.querySelector('[data-shortlist-count-label]').textContent=this.dataset.shortlistCount.replace('__COUNT__',String(selection.size));hint.textContent=selection.size===3?this.dataset.shortlistLimit:hint.dataset.initialHint;
   inquiry.setAttribute('aria-disabled',String(selection.size===0));inquiry.tabIndex=selection.size?0:-1;updateEntries();
  };
  const renderRows=()=>{
   list.replaceChildren();selection.forEach(record=>{const fragment=template.content.cloneNode(true),row=fragment.querySelector('li'),image=fragment.querySelector('[data-shortlist-image]'),link=fragment.querySelector('[data-shortlist-model]'),quantity=fragment.querySelector('[data-shortlist-quantity-input]');row.dataset.shortlistKey=record.key;image.src=record.image;link.textContent=record.title;link.href=record.url;quantity.value=record.quantity;quantity.setAttribute('aria-label',this.dataset.shortlistQuantity+' · '+record.title);fragment.querySelector('[data-shortlist-remove-model]').textContent=' · '+record.title;list.append(fragment)});
   this.querySelector('[data-shortlist-empty]').hidden=selection.size>0;updateSelection();
  };
  const cancelModal=()=>{const current=dialog?.open?{opacity:getComputedStyle(dialog).opacity,transform:getComputedStyle(dialog).transform}:null;revision++;modalAnimation?.cancel();modalAnimation=null;return current};
  const restoreOrigin=()=>{if(!origin&&!this.pageLock)return;this.unlockPage();updateEntries();const fallback=origin?.closest('[data-catalog-model]')?.querySelector('[data-shortlist-toggle]')||lastToggle;const target=origin&&!origin.hidden?origin:fallback;if(target?.isConnected)target.focus({preventScroll:true});origin=null};
  const finishClose=()=>{cancelModal();if(dialog.open)dialog.close();restoreOrigin()};
  const closeDialog=()=>{if(!dialog?.open||dialog.dataset.motionState==='closing')return;const current=cancelModal();dialog.dataset.motionState='closing';if(this.preference.matches||!dialog.animate){finishClose();return}const token=revision;modalAnimation=track(dialog.animate([current,{opacity:0,transform:'translateY(6px)'}],{duration:140,easing:'ease-in',fill:'both'}));modalAnimation.onfinish=()=>{if(token===revision)finishClose()}};
  if(supported){
   hint.dataset.initialHint=hint.textContent;
   cards.forEach(card=>{const button=card.querySelector('[data-shortlist-toggle]'),link=card.querySelector('h2 a'),image=card.querySelector('.tl-catalog__model-image img');if(!button||!link||!image||!card.dataset.shortlistKey)return;const url=new URL(link.href,location.href);if(url.origin!==location.origin)return;const record={key:card.dataset.shortlistKey,button,title:link.textContent.trim(),url:url.href,image:image.currentSrc||image.src,imageSource:image,quantity:'1'};records.set(record.key,record);button.hidden=false;button.parentElement.hidden=false;on(button,'click',()=>{lastToggle=button;if(selection.has(record.key)){selection.delete(record.key);announce(this.dataset.shortlistRemoved.replace('__MODEL__',record.title))}else if(selection.size<3){record.image=record.imageSource.currentSrc||record.imageSource.src;selection.set(record.key,{...record});announce(this.dataset.shortlistAdded.replace('__MODEL__',record.title))}else{announce(this.dataset.shortlistLimit);return}updateSelection();if(!this.preference.matches&&button.animate)track(button.animate([{opacity:.65},{opacity:1}],{duration:180,easing:'ease-out'}))})});
   bar.hidden=records.size===0;updateSelection();
   const openDialog=event=>{origin=event.currentTarget;const current=cancelModal(),wasOpen=dialog.open;renderRows();if(!wasOpen){lockPage();dialog.showModal();}dialog.dataset.motionState='open';if(!this.preference.matches&&dialog.animate){const token=revision;modalAnimation=track(dialog.animate([wasOpen?current:{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:200,easing:'cubic-bezier(.2,.7,.2,1)',fill:'both'}));modalAnimation.onfinish=()=>{if(token===revision){modalAnimation.cancel();modalAnimation=null}}}};
   on(view,'click',openDialog);on(endView,'click',openDialog);cardViews.forEach(button=>on(button,'click',openDialog));
   on(this.querySelector('[data-shortlist-close]'),'click',closeDialog);on(dialog,'cancel',event=>{event.preventDefault();closeDialog()});
   on(dialog,'click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)closeDialog()});
   on(dialog,'close',()=>{if(dialog.open)return;cancelModal();delete dialog.dataset.motionState;restoreOrigin()});
   on(list,'input',event=>{const input=event.target.closest('[data-shortlist-quantity-input]'),row=input?.closest('[data-shortlist-key]'),record=row&&selection.get(row.dataset.shortlistKey);if(record)record.quantity=input.value});
   on(list,'click',event=>{const remove=event.target.closest('[data-shortlist-remove]');if(!remove)return;const row=remove.closest('[data-shortlist-key]'),key=row.dataset.shortlistKey,record=selection.get(key),keys=[...selection.keys()],index=keys.indexOf(key);selection.delete(key);renderRows();announce(this.dataset.shortlistRemoved.replace('__MODEL__',record.title));const next=list.querySelectorAll('[data-shortlist-remove]')[Math.min(index,selection.size-1)];(next||this.querySelector('[data-shortlist-close]')).focus({preventScroll:true})});
   const prepare=event=>{if(event.type==='auxclick'&&event.button!==1)return;if(!selection.size||!form.reportValidity()){event.preventDefault();return}const brief=[this.dataset.shortlistBrief,...[...selection.values()].map((record,index)=>`${index+1}. ${record.title} | ${this.dataset.shortlistQuantity}: ${Number(record.quantity)} | ${record.url}`),'',this.dataset.shortlistBriefNote].join('\n'),target=new URL(inquiry.href,location.href);if(target.origin!==location.origin){event.preventDefault();return}target.searchParams.set('brief',brief);target.searchParams.set('source_page',location.pathname);inquiry.href=target.pathname+target.search+target.hash};
   on(inquiry,'click',prepare);on(inquiry,'auxclick',prepare);on(form,'submit',event=>event.preventDefault());
  }
  on(this.preference,'change',()=>{if(!this.preference.matches)return;if(dialog?.dataset.motionState==='closing')finishClose();else cancelModal();cancelMotion()});on(document,'visibilitychange',()=>{if(document.hidden){if(dialog?.dataset.motionState==='closing')finishClose();else cancelModal();cancelMotion()}});
 }
 disconnectedCallback(){this.abort?.abort();this.abort=null;this.unlockPage?.();this.animations?.forEach(animation=>animation.cancel());this.animations?.clear();if(this.dialog?.open)this.dialog.close();if(this.dialog)delete this.dialog.dataset.motionState;this.selection?.clear();this.querySelector('[data-catalog-controls]')?.setAttribute('hidden','');this.querySelector('[data-shortlist-bar]')?.setAttribute('hidden','');this.querySelector('[data-shortlist-end-view]')?.setAttribute('hidden','');this.querySelectorAll('[data-shortlist-card-view]').forEach(button=>button.hidden=true);this.querySelectorAll('.tl-catalog__model-actions').forEach(actions=>actions.hidden=true);this.querySelectorAll('[data-shortlist-toggle]').forEach(button=>{button.hidden=true;button.disabled=false;button.setAttribute('aria-pressed','false')})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-company-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-company-film')) {
    customElements.define('tl-company-film', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.track = this.querySelector('[data-film-track]');
        this.frames = [...this.querySelectorAll('[data-film-frame]')];
        if (!this.track || !this.frames.length) return;
        this.animations = [];
        this.previous = this.querySelector('[data-film-previous]');
        this.next = this.querySelector('[data-film-next]');
        this.count = this.querySelector('[data-film-count]');
        this.querySelector('[data-film-controls]').hidden = this.frames.length < 2;
        this.previous.addEventListener('click', () => this.go(-1), {signal: this.controller.signal});
        this.next.addEventListener('click', () => this.go(1), {signal: this.controller.signal});
        this.track.addEventListener('scroll', () => this.update(), {passive: true, signal: this.controller.signal});
        ['pointerdown', 'wheel', 'keydown'].forEach(type => this.track.addEventListener(type, () => this.cancelScroll(), {passive: true, signal: this.controller.signal}));
        window.addEventListener('resize', () => { this.cancelScroll(); this.update(); }, {passive: true, signal: this.controller.signal});
        this.motion.addEventListener('change', () => { if (this.motion.matches) { this.cancelScroll(); this.animations.forEach(a => a.cancel()); } }, {signal: this.controller.signal});
        if (window.IntersectionObserver) {
          this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            if (!this.motion.matches && entry.target.animate) this.animations.push(entry.target.animate([{transform: 'scale(.99)', opacity: .88}, {transform: 'scale(1)', opacity: 1}], {duration: 600, easing: 'cubic-bezier(.16,1,.3,1)'}));
          }), {threshold: .2});
          this.frames.forEach(frame => this.observer.observe(frame));
        }
        this.update();
      }
      offsets() { return this.frames.map(frame => frame.offsetLeft - this.frames[0].offsetLeft); }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const offsets = this.offsets();
        this.index = offsets.reduce((best, value, i) => Math.abs(value - this.track.scrollLeft) < Math.abs(offsets[best] - this.track.scrollLeft) ? i : best, 0);
        if (this.track.scrollLeft >= max - 2) this.index = this.frames.length - 1;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
        this.count.textContent = String(this.index + 1).padStart(2, '0') + ' / ' + String(this.frames.length).padStart(2, '0');
      }
      go(direction) {
        this.cancelScroll();
        const index = Math.min(this.frames.length - 1, Math.max(0, this.index + direction));
        const target = Math.min(this.offsets()[index], this.track.scrollWidth - this.track.clientWidth);
        if (this.motion.matches) { this.track.scrollLeft = target; return; }
        const from = this.track.scrollLeft;
        const started = performance.now();
        this.track.style.scrollSnapType = 'none';
        const tick = now => {
          const progress = Math.min(1, (now - started) / 650);
          this.track.scrollLeft = from + (target - from) * (1 - Math.pow(1 - progress, 3));
          if (progress < 1) this.frame = requestAnimationFrame(tick);
          else { this.frame = 0; this.track.style.scrollSnapType = ''; this.update(); }
        };
        this.frame = requestAnimationFrame(tick);
      }
      cancelScroll() { cancelAnimationFrame(this.frame); this.frame = 0; if (this.track) this.track.style.scrollSnapType = ''; }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.cancelScroll(); this.animations?.forEach(a => a.cancel()); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-decision-board"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-decision-board'))customElements.define('tl-decision-board',class extends HTMLElement{
  connectedCallback(){
    if(this.abort&&!this.abort.signal.aborted)return;
    this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];
    this.section=this.querySelector('.tl-decision');this.buttons=[...this.querySelectorAll('[data-decision-choice]')];this.panels=[...this.querySelectorAll('[data-decision-panel]')];this.all=this.querySelector('[data-decision-all]');this.status=this.querySelector('[data-decision-status]');
    if(!this.buttons.length)return;
    this.querySelector('[data-decision-choices]').hidden=false;this.all.hidden=false;this.section.classList.add('is-enhanced');
    this.panels.forEach(panel=>{panel.open=true;panel.querySelector('summary').tabIndex=-1;const a=panel.querySelector('[data-decision-quote]');if(a){const u=new URL(a.href,location.href);u.searchParams.set('type',this.dataset.type||'project');u.searchParams.set('brief',`${this.dataset.request}\n${this.dataset.subject}\n${panel.dataset.question}`.slice(0,4000));u.searchParams.set('source_page',location.pathname);a.href=u.pathname+u.search;}});
    this.buttons.forEach((button,i)=>button.addEventListener('click',()=>this.select(i),{signal:this.abort.signal}));
    this.all.addEventListener('click',()=>this.select(this.all.getAttribute('aria-pressed')==='true'?this.current:-1),{signal:this.abort.signal});
    this.addEventListener('shopify:block:select',event=>{const i=this.panels.findIndex(p=>p===event.target||p.contains(event.target));if(i>=0)this.select(i,false);},{signal:this.abort.signal});
    this.motion.addEventListener('change',()=>{if(this.motion.matches)this.cancel();},{signal:this.abort.signal});
    this.current=0;this.select(0,false);
  }
  cancel(){this.animations.forEach(a=>a.cancel());this.animations=[];}
  select(index,animate=true){
    this.cancel();const all=index<0;if(!all)this.current=index;
    this.buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(!all&&i===index)));
    this.all.setAttribute('aria-pressed',String(all));this.all.querySelector('span').textContent=all?'−':'＋';this.querySelector('[data-decision-panels]').dataset.all=String(all);
    this.panels.forEach((panel,i)=>{panel.hidden=!all&&i!==index;panel.open=true;});
    this.status.textContent=all?this.all.textContent.replace('＋','').trim():this.panels[index]?.dataset.question||'';
    const panel=this.panels[index];if(animate&&!all&&!this.motion.matches&&panel?.animate){const a=panel.animate([{opacity:.55,transform:'translateY(4px)'},{opacity:1,transform:'translateY(0)'}],{duration:200,easing:'ease-out'});this.animations.push(a);a.addEventListener('finish',()=>this.animations=this.animations.filter(x=>x!==a),{once:true});}
  }
  disconnectedCallback(){this.abort?.abort();this.cancel();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-document-exhibit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-document-exhibit'))customElements.define('tl-document-exhibit',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.tabs=[...this.querySelectorAll('[data-exhibit-tab]')];this.panels=[...this.querySelectorAll('[data-exhibit-panel]')];if(!this.tabs.length||this.tabs.length!==this.panels.length)return;const nav=this.querySelector('[data-exhibit-tabs]');nav.hidden=false;nav.setAttribute('role','tablist');this.tabs.forEach((tab,index)=>{tab.setAttribute('role','tab');tab.addEventListener('click',()=>this.select(index));tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;else if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.tabs.length-1;else return;event.preventDefault();this.select(next);this.tabs[next].focus();this.tabs[next].scrollIntoView({block:'nearest',inline:'nearest'})})});this.panels.forEach((panel,index)=>{panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',this.tabs[index].id)});this.select(0,false)}
 select(index,motion=true){if(this.activeAnimation)this.activeAnimation.cancel();this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',i===index?'true':'false');tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index});if(motion&&!matchMedia('(prefers-reduced-motion: reduce)').matches){const scan=this.panels[index].querySelector('figure');this.activeAnimation=scan.animate([{opacity:.65,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:260,easing:'ease-out'});this.activeAnimation.onfinish=()=>{this.activeAnimation=null}}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-factory-evidence"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-factory-evidence'))customElements.define('tl-factory-evidence',class extends HTMLElement{
  connectedCallback(){if(this.releases)return;this.releases=[...this.querySelectorAll('details')].map(item=>window.TaillaiDisclosureMotion?.attach(item)).filter(Boolean);}
  disconnectedCallback(){this.releases?.forEach(release=>release());this.releases=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-factory-scenes"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-factory-scenes'))customElements.define('tl-factory-scenes',class extends HTMLElement{
  connectedCallback(){
    if(this.abort)return;
    this.abort=new AbortController();const signal=this.abort.signal;
    this.frames=[...this.querySelectorAll('.tl-factory-scenes__photos figure')];
    this.buttons=[...this.querySelectorAll('[data-scene]')];this.dialog=this.querySelector('dialog');
    this.reduce=matchMedia('(prefers-reduced-motion: reduce)');this.selectionRequest=0;this.viewerRequest=0;this.selected=0;
    this.setAttribute('data-enhanced','');this.querySelector('.tl-factory-scenes__nav').hidden=false;this.commit(0,false);
    this.buttons.forEach((button,index)=>{
      button.addEventListener('click',()=>this.select(index,true),{signal});
      button.addEventListener('keydown',event=>{
        let next;if(event.key==='ArrowRight')next=(index+1)%this.buttons.length;
        if(event.key==='ArrowLeft')next=(index-1+this.buttons.length)%this.buttons.length;
        if(event.key==='Home')next=0;if(event.key==='End')next=this.buttons.length-1;
        if(next!==undefined){event.preventDefault();this.select(next,true);this.buttons[next].focus({preventScroll:true});}
      },{signal});
    });
    this.querySelectorAll('[data-factory-zoom]').forEach(link=>link.addEventListener('click',event=>{
      if(!this.dialog?.showModal||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.altKey||event.shiftKey)return;
      event.preventDefault();this.openPhoto(link);
    },{signal}));
    this.dialog.querySelector('[data-close]').addEventListener('click',()=>this.closePhoto(),{signal});
    this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.closePhoto();},{signal});
    this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const box=this.dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)this.closePhoto();}},{signal});
    this.dialog.addEventListener('close',()=>{if(!this.dialog.open&&this.scrollState)this.releaseViewer(true);},{signal});
    this.reduce.addEventListener('change',()=>{if(this.reduce.matches)this.motion?.cancel();},{signal});
    document.addEventListener('shopify:block:select',event=>{const index=this.frames.indexOf(event.target.closest('figure'));if(index>=0)this.select(index,false);},{signal});
  }
  async select(index,animate){
    const frame=this.frames[index],signal=this.abort?.signal;if(!frame||!signal)return;
    const request=++this.selectionRequest;if(index===this.selected)return;
    const photo=frame.querySelector('img');photo.loading='eager';
    try{await photo.decode();}catch(error){return;}
    if(request!==this.selectionRequest||signal.aborted||!this.isConnected||!photo.naturalWidth)return;
    this.commit(index,animate);
  }
  commit(index,animate){
    this.motion?.cancel();this.motion=null;this.selected=index;
    this.frames.forEach((frame,i)=>{frame.hidden=i!==index;this.buttons[i]?.setAttribute('aria-pressed',String(i===index));});
    const image=this.frames[index]?.querySelector('img');
    if(animate&&image&&!this.reduce.matches){
      const motion=image.animate([{opacity:.88},{opacity:1}],{duration:160,easing:'ease-out'});
      this.motion=motion;motion.onfinish=()=>{if(this.motion===motion){motion.cancel();this.motion=null;}};
    }
  }
  async openPhoto(link){
    if(!this.dialog.open&&this.scrollState)this.releaseViewer(true);
    const source=link.querySelector('img'),image=this.dialog.querySelector('img'),signal=this.abort.signal;
    const request=++this.viewerRequest;
    try{await source.decode();}catch(error){return;}
    if(request!==this.viewerRequest||signal.aborted||!link.isConnected||!source.naturalWidth)return;
    const fallback=source.currentSrc||source.src;
    image.src=fallback;image.alt=source.alt;image.width=source.naturalWidth;image.height=source.naturalHeight;
    image.style.aspectRatio=`${source.naturalWidth} / ${source.naturalHeight}`;
    image.style.width=`min(${source.naturalWidth}px, 100%, calc(72dvh * ${source.naturalWidth/source.naturalHeight}))`;
    try{await image.decode();}catch(error){return;}
    if(request!==this.viewerRequest||signal.aborted||!link.isConnected)return;
    this.opener=link;
    this.dialog.querySelector('p').textContent=[...link.closest('figure').querySelector('figcaption').children].map(node=>node.textContent.trim()).join(' — ');
    if(!this.dialog.open){
      const root=document.documentElement;
      const properties=[[root,'overflow'],[root,'scrollbar-gutter'],[document.body,'overflow']];
      this.scrollState={x:scrollX,y:scrollY,styles:properties.map(([element,name])=>[element,name,element.style.getPropertyValue(name),element.style.getPropertyPriority(name)])};
      root.style.setProperty('scrollbar-gutter','stable');root.style.setProperty('overflow','hidden');document.body.style.setProperty('overflow','hidden');
      this.dialog.showModal();this.dialog.scrollTop=0;
    }
    this.dialog.querySelector('[data-close]').focus({preventScroll:true});
    if(link.href!==fallback){
      const large=new Image();large.decoding='async';large.src=link.href;
      large.decode().then(()=>{if(request===this.viewerRequest&&!signal.aborted&&this.dialog.open&&this.opener===link)image.src=large.src;}).catch(()=>{});
    }
  }
  releaseViewer(restore){
    this.viewerRequest+=1;const saved=this.scrollState;this.scrollState=null;
    saved?.styles.forEach(([element,name,value,priority])=>{if(value)element.style.setProperty(name,value,priority);else element.style.removeProperty(name);});
    if(restore&&this.opener?.isConnected)this.opener.focus({preventScroll:true});this.opener=null;
    if(saved)window.scrollTo({left:saved.x,top:saved.y,behavior:'instant'});
    this.dialog.querySelector('img').removeAttribute('src');
  }
  closePhoto(){if(this.dialog.open)this.dialog.close();this.releaseViewer(true);}
  disconnectedCallback(){
    this.abort?.abort();this.selectionRequest+=1;this.motion?.cancel();
    if(this.dialog?.open)this.dialog.close();this.releaseViewer(false);this.abort=null;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-factory-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-factory-video')) {
  customElements.define('tl-factory-video', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.video = this.querySelector('[data-factory-video]');
      if (!this.video) return;
      this.bound = true;
      this.status = this.querySelector('[data-video-status]');
      this.onClick = event => {
        const button = event.target.closest('[data-video-seek]');
        if (!button || !this.contains(button)) return;
        const seconds = Number(button.dataset.videoSeek);
        if (!Number.isFinite(seconds)) return;
        this.pendingChapter = { seconds: Math.max(0, seconds), title: button.dataset.chapterTitle || '' };
        if (this.video.readyState >= 1) this.seekChapter();
        else this.video.load();
      };
      this.onMetadata = () => this.seekChapter();
      this.onError = () => {
        this.pendingChapter = null;
        this.video.hidden = true;
        const fallback = this.querySelector('[data-video-fallback]');
        if (fallback) fallback.hidden = false;
        this.querySelectorAll('[data-video-seek]').forEach(button => { button.disabled = true; });
        if (this.status) this.status.textContent = this.status.dataset.errorLabel;
      };
      this.addEventListener('click', this.onClick);
      this.video.addEventListener('loadedmetadata', this.onMetadata);
      this.video.addEventListener('error', this.onError);
    }
    seekChapter() {
      if (!this.pendingChapter || !this.video) return;
      const chapter = this.pendingChapter;
      this.pendingChapter = null;
      const maximum = Number.isFinite(this.video.duration) ? Math.max(0, this.video.duration - .05) : chapter.seconds;
      try { this.video.currentTime = Math.min(chapter.seconds, maximum); }
      catch { return; }
      if (this.status) this.status.textContent = `${this.status.dataset.seekLabel} ${chapter.title}`;
      const playAttempt = this.video.play();
      if (playAttempt?.catch) playAttempt.catch(() => {});
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.video?.removeEventListener('loadedmetadata', this.onMetadata);
      this.video?.removeEventListener('error', this.onError);
      this.video?.pause();
      this.pendingChapter = null;
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-hero-carousel')) customElements.define('tl-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const { signal } = this._abort;
      const slides = [...this.querySelectorAll('[data-slide]')];
      const dots = [...this.querySelectorAll('[data-dot]')];
      if (slides.length < 2) return;
      const viewport = this.querySelector('.tl-hero__viewport');
      const controls = this.querySelector('.tl-hero__controls');
      const status = this.querySelector('[data-status]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const delay = Number(this.dataset.autoplay) || 0;
      let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      let animations = [];
      let revision = 0;
      let timer;
      let gesture;
      let suppressClick = false;
      let hovered = false;
      const settle = () => {
        revision += 1;
        animations.forEach(animation => animation.cancel());
        animations = [];
        slides.forEach(slide => slide.classList.remove('is-transitioning'));
      };
      const updateTimer = () => {
        clearTimeout(timer);
        if (!delay || motion.matches || document.hidden || hovered || gesture || this.contains(document.activeElement) || window.Shopify?.designMode) return;
        timer = setTimeout(() => go(index + 1, { announce: false, direction: 1 }), delay);
      };
      const go = (next, options = {}) => {
        next = (next + slides.length) % slides.length;
        const previous = index;
        if (next === index && !options.instant) {
          if (options.focus) dots[index]?.focus({ preventScroll: true });
          return;
        }
        const direction = options.direction || (next > previous ? 1 : -1);
        const states = new Map();
        if (!motion.matches && !options.instant) {
          slides.forEach(slide => {
            if (!slide.classList.contains('is-active') && !slide.classList.contains('is-transitioning')) return;
            [...slide.querySelectorAll('.tl-hero__copy, .tl-hero__stage')].forEach(element => {
              const style = getComputedStyle(element);
              states.set(element, { opacity: style.opacity, transform: style.transform });
            });
          });
        }
        settle();
        index = next;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
          dot.tabIndex = active ? 0 : -1;
        });
        if (!motion.matches && !options.instant && typeof slides[index].animate === 'function') {
          const token = revision;
          slides.forEach((slide, i) => {
            const active = i === index;
            const elements = [...slide.querySelectorAll('.tl-hero__copy, .tl-hero__stage')];
            if (!active && !elements.some(element => states.has(element))) return;
            slide.classList.add('is-transitioning');
            elements.forEach(element => {
              const stage = element.classList.contains('tl-hero__stage');
              const start = states.get(element) || { opacity: 0, transform: `translateX(${direction * (stage ? 36 : 16)}px)` };
              const end = { opacity: active ? 1 : 0, transform: active ? 'translateX(0)' : `translateX(${-direction * (stage ? 28 : 10)}px)` };
              animations.push(element.animate([start, end], {
                duration: active ? (stage ? 460 : 320) : (stage ? 300 : 220),
                easing: 'cubic-bezier(.22, 1, .36, 1)',
                fill: 'both'
              }));
            });
          });
          if (dots[index]) animations.push(dots[index].animate([{ transform: 'scale(.98)' }, { transform: 'scale(1)' }], { duration: 240, easing: 'cubic-bezier(.22, 1, .36, 1)' }));
          Promise.all(animations.map(animation => animation.finished.catch(() => {}))).then(() => {
            if (token === revision) settle();
          });
        }
        if (options.announce !== false && status) status.textContent = dots[index]?.textContent.trim() || slides[index].querySelector('.tl-hero__model')?.textContent.trim() || '';
        if (options.focus || (options.announce !== false && slides[previous].contains(document.activeElement))) dots[index]?.focus({ preventScroll: true });
        updateTimer();
      };
      this.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1, { direction: -1 }), { signal });
      this.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1, { direction: 1 }), { signal });
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), { signal }));
      dots.forEach((dot, i) => dot.addEventListener('keydown', event => {
        const next = event.key === 'ArrowRight' ? i + 1 : event.key === 'ArrowLeft' ? i - 1 : event.key === 'Home' ? 0 : event.key === 'End' ? dots.length - 1 : null;
        if (next === null) return;
        event.preventDefault();
        go(next, { focus: true, direction: event.key === 'ArrowLeft' ? -1 : event.key === 'ArrowRight' ? 1 : undefined });
      }, { signal }));

      const cancelGesture = () => {
        if (gesture && viewport.hasPointerCapture(gesture.id)) viewport.releasePointerCapture(gesture.id);
        gesture = null;
        updateTimer();
      };
      viewport.addEventListener('pointerdown', event => {
        suppressClick = false;
        if (!event.isPrimary || event.button !== 0 || event.target.closest('button, input, select, textarea, [contenteditable]')) return;
        if (event.pointerType === 'mouse' && !event.target.closest('.tl-hero__stage')) return;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, time: performance.now(), locked: false };
        clearTimeout(timer);
      }, { signal });
      viewport.addEventListener('pointermove', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const x = event.clientX - gesture.x;
        const y = event.clientY - gesture.y;
        if (!gesture.locked && Math.abs(y) > 8 && Math.abs(y) > Math.abs(x) * 1.15) {
          cancelGesture();
          return;
        }
        if (!gesture.locked && Math.abs(x) > 12 && Math.abs(x) > Math.abs(y) * 1.35) {
          gesture.locked = true;
          viewport.setPointerCapture(event.pointerId);
        }
        if (!gesture.locked) return;
        event.preventDefault();
      }, { signal, passive: false });
      window.addEventListener('pointerup', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        if (gesture.locked) {
          const distance = event.clientX - gesture.x;
          const velocity = Math.abs(distance) / Math.max(1, performance.now() - gesture.time);
          const threshold = Math.max(36, Math.min(72, viewport.clientWidth * .09));
          suppressClick = true;
          if (Math.abs(distance) >= threshold || (Math.abs(distance) > 20 && velocity > .45)) go(index + (distance < 0 ? 1 : -1), { direction: distance < 0 ? 1 : -1 });
        }
        cancelGesture();
      }, { signal });
      window.addEventListener('pointercancel', cancelGesture, { signal });
      window.addEventListener('blur', cancelGesture, { signal });
      viewport.addEventListener('click', event => {
        if (!suppressClick || event.detail === 0) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      }, { signal, capture: true });
      viewport.addEventListener('dragstart', event => {
        if (gesture && event.target.closest('.tl-hero__media')) event.preventDefault();
      }, { signal });
      this.addEventListener('mouseenter', () => { hovered = true; updateTimer(); }, { signal });
      this.addEventListener('mouseleave', () => { hovered = false; if (gesture && !gesture.locked) cancelGesture(); updateTimer(); }, { signal });
      this.addEventListener('focusin', updateTimer, { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => { if (!signal.aborted) updateTimer(); }), { signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) settle(); updateTimer(); }, { signal });
      motion.addEventListener('change', () => { settle(); updateTimer(); }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-slide]');
        const selected = slides.indexOf(slide);
        if (selected !== -1) go(selected, { instant: true, announce: false });
      }, { signal });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(this)) this.disconnectedCallback();
      }, { signal });
      signal.addEventListener('abort', () => {
        clearTimeout(timer);
        settle();
        if (gesture && viewport.hasPointerCapture(gesture.id)) viewport.releasePointerCapture(gesture.id);
        gesture = null;
        this.classList.remove('is-ready');
        if (controls) controls.hidden = true;
      }, { once: true });
      this.classList.add('is-ready');
      if (controls) controls.hidden = false;
      go(index, { instant: true, announce: false });
    }
    disconnectedCallback() { this._abort?.abort(); this._abort = null; }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-home-factory-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-home-factory-story')) {
  customElements.define('tl-home-factory-story', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.panels = [...this.querySelectorAll('[data-factory-panel]')];
      this.tabs = [...this.querySelectorAll('[data-factory-tab]')];
      this.panelGroup = this.querySelector('[data-factory-panels]');
      this.dialog = this.querySelector('dialog');
      this.requestVersion = 0;
      this.photoRequestVersion = (this.photoRequestVersion || 0) + 1;
      this.focusIndex = 0;
      this.activeIndex = 0;
      if (!this.panels.length) return;
      this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.reduceMotion.addEventListener('change', event => {
        if (event.matches) this.motion?.cancel();
      }, { signal });
      this.panels.forEach((panel, index) => {
        panel.querySelector('.tl-factory-story__image').addEventListener('error', () => this.ensurePhoto(index), { signal });
      });
      this.setAttribute('data-enhanced', '');
      this.querySelector('[role="tablist"]').hidden = false;
      this.commit(0, false);
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.focusIndex = index;
          this.updateTabStops();
          this.select(index, true);
        }, { signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.focusIndex = next;
          this.updateTabStops();
          this.tabs[next].focus({ preventScroll: true });
        }, { signal });
      });
      this.querySelectorAll('[data-factory-enlarge]').forEach(link => {
        link.addEventListener('click', event => {
          if (!this.dialog?.showModal || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.openPhoto(link);
        }, { signal });
      });
      this.querySelector('[data-factory-close]').addEventListener('click', () => this.closePhoto(), { signal });
      this.dialog.addEventListener('cancel', event => {
        event.preventDefault();
        this.closePhoto();
      }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.closePhoto();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        if (!this.dialog.open && this.scrollState) {
          this.photoRequestVersion += 1;
          this.restoreScroll(true);
        }
      }, { signal });
      this.querySelector('[data-factory-dialog-image]').addEventListener('error', event => {
        const photo = event.currentTarget;
        if (this.dialog.open && this.modalFallback && photo.src !== this.modalFallback) photo.src = this.modalFallback;
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const blockId = event.detail?.blockId;
        const panel = event.target.closest?.('[data-factory-panel]');
        const index = this.panels.findIndex(item => item === panel || item.dataset.blockId === blockId);
        if (index < 0) return;
        this.focusIndex = index;
        this.select(index, false);
      }, { signal });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target === this || event.target.contains?.(this)) this.destroy();
      }, { signal });
    }
    updateTabStops() {
      this.tabs.forEach((tab, index) => { tab.tabIndex = index === this.focusIndex ? 0 : -1; });
    }
    async select(index, animate) {
      const panel = this.panels[index];
      if (!panel) return;
      const request = ++this.requestVersion;
      const photo = panel.querySelector('.tl-factory-story__image');
      if (photo && (!photo.complete || !photo.naturalWidth)) {
        this.panelGroup.setAttribute('aria-busy', 'true');
      }
      const loaded = await this.ensurePhoto(index);
      if (request !== this.requestVersion || !this.abort || !this.isConnected) return;
      this.panelGroup.removeAttribute('aria-busy');
      if (!loaded) return;
      this.commit(index, animate);
    }
    async ensurePhoto(index) {
      const panel = this.panels[index];
      const photo = panel?.querySelector('.tl-factory-story__image');
      if (!photo) return false;
      if (photo.complete && photo.naturalWidth) return true;
      photo.loading = 'eager';
      try {
        await photo.decode();
        if (photo.naturalWidth) return true;
      } catch (error) { }
      const fallback = new URL(panel.dataset.fallbackUrl, document.baseURI).href;
      if (!this.abort || photo.src === fallback) return false;
      photo.removeAttribute('srcset');
      photo.src = fallback;
      try { await photo.decode(); } catch (error) { }
      if (photo.naturalWidth) panel.querySelector('[data-factory-enlarge]').href = fallback;
      return photo.complete && photo.naturalWidth > 0;
    }
    commit(index, animate) {
      this.motion?.cancel();
      this.panels.forEach((panel, position) => {
        panel.hidden = position !== index;
        panel.setAttribute('role', 'tabpanel');
        panel.tabIndex = position === index ? 0 : -1;
        this.tabs[position].setAttribute('aria-selected', String(position === index));
      });
      this.updateTabStops();
      const changed = this.activeIndex !== index;
      this.activeIndex = index;
      const photo = this.panels[index].querySelector('.tl-factory-story__image');
      if (animate && changed && photo?.complete && photo.naturalWidth && !this.reduceMotion.matches) {
        this.motion = photo.animate([{ opacity: .7 }, { opacity: 1 }], { duration: 160, easing: 'ease-out' });
      }
    }
    async openPhoto(link) {
      if (this.dialog.open) return;
      if (this.scrollState) this.restoreScroll(false);
      const request = ++this.photoRequestVersion;
      const panel = link.closest('[data-factory-panel]');
      const source = link.querySelector('.tl-factory-story__image');
      if (!source) return;
      if (!source.complete || !source.naturalWidth) {
        if (!await this.ensurePhoto(this.panels.indexOf(panel))) return;
      }
      try { await source.decode(); } catch (error) { return; }
      if (request !== this.photoRequestVersion || !this.abort || !this.isConnected || this.dialog.open || panel.hidden) return;
      this.opener = link;
      const image = this.querySelector('[data-factory-dialog-image]');
      this.modalFallback = source.currentSrc || source.src;
      image.width = source.naturalWidth;
      image.height = source.naturalHeight;
      image.style.aspectRatio = `${source.naturalWidth} / ${source.naturalHeight}`;
      image.style.width = `min(${source.naturalWidth}px, 100%, calc(72dvh * ${source.naturalWidth / source.naturalHeight}))`;
      image.src = this.modalFallback;
      image.alt = source.alt || '';
      const caption = panel.querySelector('figcaption');
      this.querySelector('[data-factory-dialog-caption]').textContent = [...caption.children].map(item => item.textContent.trim()).join(' — ');
      try { await image.decode(); } catch (error) { return; }
      if (request !== this.photoRequestVersion || !this.abort || !this.isConnected || this.dialog.open || panel.hidden) return;
      if (!this.scrollState) {
        const root = document.documentElement;
        this.scrollState = { x: scrollX, y: scrollY, overflow: root.style.getPropertyValue('overflow'), priority: root.style.getPropertyPriority('overflow') };
        root.style.setProperty('overflow', 'hidden');
      }
      this.dialog.showModal();
      this.querySelector('[data-factory-close]').focus({ preventScroll: true });
      if (link.href !== this.modalFallback) {
        const large = new Image();
        large.decoding = 'async';
        large.src = link.href;
        large.decode().then(() => {
          if (request !== this.photoRequestVersion || !this.abort || !this.isConnected || !this.dialog.open || this.opener !== link) return;
          image.src = large.src;
        }).catch(() => {});
      }
    }
    restoreScroll(returnFocus) {
      const state = this.scrollState;
      if (!state) return;
      this.scrollState = null;
      const root = document.documentElement;
      if (state.overflow) root.style.setProperty('overflow', state.overflow, state.priority);
      else root.style.removeProperty('overflow');
      if (returnFocus && this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
    }
    closePhoto() {
      this.photoRequestVersion += 1;
      if (this.dialog.open) this.dialog.close();
      this.restoreScroll(true);
    }
    destroy() {
      this.requestVersion += 1;
      this.photoRequestVersion += 1;
      this.motion?.cancel();
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll(false);
      this.abort?.abort();
      this.abort = null;
      this.panelGroup?.removeAttribute('aria-busy');
    }
    disconnectedCallback() { this.destroy(); }
  });
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches?.('tl-home-factory-story')) event.target.connectedCallback();
    event.target.querySelectorAll?.('tl-home-factory-story').forEach(story => story.connectedCallback());
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-home-intent-path"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-home-intent-path')) customElements.define('tl-home-intent-path', class extends HTMLElement {
  connectedCallback() {
    if (this._abort) return;
    this._abort = new AbortController();
    const { signal } = this._abort;
    const tabs = [...this.querySelectorAll('[data-intent-tab]')];
    const panels = [...this.querySelectorAll('[data-intent-panel]')];
    const choices = this.querySelector('[data-intent-choices]');
    const status = this.querySelector('[data-intent-status]');
    if (!choices || !tabs.length || panels.length !== tabs.length) return;
    const select = (index, announce = false) => {
      this._selected = Math.max(0, Math.min(index, tabs.length - 1));
      tabs.forEach((tab, i) => {
        const active = i === this._selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        panels[i].querySelector('details').open = true;
        panels[i].hidden = !active;
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tab.id);
        panels[i].tabIndex = 0;
      });
      if (announce && status) status.textContent = panels[this._selected].querySelector('h3')?.textContent || '';
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i, true), { signal });
      tab.addEventListener('keydown', event => {
        const next = event.key === 'ArrowRight' ? (i + 1) % tabs.length : event.key === 'ArrowLeft' ? (i + tabs.length - 1) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : null;
        if (next === null) return;
        event.preventDefault();
        select(next, true);
        tabs[next].focus();
      }, { signal });
    });
    document.addEventListener('shopify:block:select', event => {
      const index = panels.findIndex(panel => panel === event.target || panel.contains(event.target));
      if (index >= 0) select(index);
    }, { signal });
    choices.hidden = false;
    this.dataset.enhanced = 'true';
    select(this._selected || 0);
  }
  disconnectedCallback() { this._abort?.abort(); this._abort = null; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-home-signature"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-home-signature'))customElements.define('tl-home-signature',class extends HTMLElement{
  connectedCallback(){
    if(this.abort&&!this.abort.signal.aborted)return;this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.buttons=[...this.querySelectorAll('[data-signature-tab]')];this.panels=[...this.querySelectorAll('[data-signature-panel]')];if(!this.buttons.length)return;
    this.classList.add('is-enhanced');this.querySelector('[data-signature-switcher]').hidden=false;this.querySelector('[data-signature-switcher]').setAttribute('role','tablist');
    this.buttons.forEach((button,index)=>{button.setAttribute('role','tab');button.addEventListener('click',()=>this.select(index),{signal:this.abort.signal});button.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?this.buttons.length-1:(index+(event.key==='ArrowRight'?1:-1)+this.buttons.length)%this.buttons.length;this.select(next);this.buttons[next].focus();},{signal:this.abort.signal});});
    this.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-signature-panel]');const i=this.panels.indexOf(panel);if(i>=0)this.select(i,false);},{signal:this.abort.signal});this.motion.addEventListener('change',()=>{if(this.motion.matches)this.cancel();},{signal:this.abort.signal});this.select(0,false);
  }
  cancel(){this.animations?.forEach(a=>a.cancel());this.animations=[];}
  select(index,animate=true){this.cancel();this.buttons.forEach((button,i)=>{button.setAttribute('aria-selected',String(i===index));button.tabIndex=i===index?0:-1;});this.panels.forEach((panel,i)=>{panel.hidden=i!==index;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',this.buttons[i].id);});const panel=this.panels[index];const img=panel.querySelector('img');if(img)img.loading='eager';this.querySelector('[data-signature-status]').textContent=panel.dataset.model;if(animate&&!this.motion.matches&&panel.animate){for(const target of [panel.querySelector('.tl-signature__figure'),panel.querySelector('.tl-signature__model-copy')]){if(!target)continue;const a=target.animate([{opacity:.35,transform:'translateY(6px)'},{opacity:1,transform:'translateY(0)'}],{duration:280,easing:'cubic-bezier(.2,.7,.2,1)'});this.animations.push(a);a.addEventListener('finish',()=>this.animations=this.animations.filter(x=>x!==a),{once:true});}}}
  disconnectedCallback(){this.abort?.abort();this.cancel();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-home-system-canvas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-home-system')) {
    customElements.define('tl-home-system', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const groups = [...this.querySelectorAll('[data-system-group]')];
        const selection = this.querySelector('[data-system-selection]');
        const quote = this.querySelector('[data-system-quote]');
        const handoff = this.querySelector('[data-system-handoff]');
        const text = key => this.querySelector(`[data-system-text="${key}"]`)?.textContent.trim() || '';
        const destination = quote ? new URL(quote.href, window.location.href) : null;
        const selected = group => group.querySelector('input:checked');
        const documentText = input => {
          const document = this.querySelector(`[data-system-document="${input.value}"] [data-system-document-body]`);
          return document ? [...document.querySelectorAll('li, p')].map(item => item.textContent.trim()).filter(Boolean).join('; ') : '';
        };
        const briefLines = () => {
          const lines = [text('summary_title')];
          groups.forEach(group => {
            const input = selected(group);
            if (!input) return;
            lines.push(`${group.dataset.label}: ${input.dataset.title}`);
            const documents = documentText(input);
            if (documents) lines.push(`${text('documents_label')}: ${documents}`);
          });
          return lines.filter(Boolean);
        };
        const update = () => {
          const choices = [];
          groups.forEach(group => {
            const input = selected(group);
            if (input) choices.push(`${group.dataset.label}: ${input.dataset.title}`);
            const panel = this.querySelector(`[data-system-documents="${group.dataset.systemGroup}"]`);
            if (!panel) return;
            panel.querySelectorAll('[data-system-document]').forEach(document => {
              document.hidden = !input || document.dataset.systemDocument !== input.value;
              document.open = !document.hidden;
            });
            const empty = panel.querySelector('[data-system-empty]');
            if (empty) empty.hidden = Boolean(input);
          });
          if (selection) selection.textContent = choices.length ? choices.join(' · ') : text('selection_empty');
          if (quote && destination?.origin === window.location.origin) {
            const url = new URL(destination);
            url.searchParams.delete('brief');
            if (choices.length) url.searchParams.set('brief', briefLines().join('\n').slice(0, 4000));
            quote.href = `${url.pathname}${url.search}${url.hash}`;
          }
        };
        const transferToBuilder = focus => {
          const builder = document.getElementById(this.dataset.builderAnchor);
          const form = builder?.querySelector('[data-builder-form]');
          if (!builder || !form) return false;
          const heating = selected(groups.find(group => group.dataset.systemGroup === 'heating'));
          const heatingQuestion = [...builder.querySelectorAll('[data-builder-question]')][3];
          const matching = heatingQuestion?.querySelectorAll('input[type="radio"]')[(Number(heating?.dataset.builderOption) || 0) - 1];
          if (matching) {
            matching.checked = true;
            matching.dispatchEvent(new Event('change', { bubbles: true }));
          }
          const hasChoices = groups.some(group => selected(group));
          if (hasChoices) {
            const contextId = `HomeSystemContext-${this.id}`;
            let context = builder.querySelector(`#${contextId}`);
            if (!context) {
              const field = document.createElement('div');
              field.className = 'tl-field tl-builder__conditions';
              const label = document.createElement('label');
              label.htmlFor = contextId;
              label.textContent = text('builder_context');
              context = document.createElement('textarea');
              context.id = contextId;
              context.rows = 5;
              context.maxLength = 1600;
              context.readOnly = true;
              context.dataset.builderExtra = '';
              context.dataset.label = text('builder_context');
              field.append(label, context);
              (form.querySelector('.tl-builder__details') || form).append(field);
            }
            context.value = briefLines().join('\n').slice(0, 1600);
            context.dispatchEvent(new Event('input', { bubbles: true }));
            this.hasTransferred = true;
            const status = this.querySelector('[data-system-status]');
            if (status) status.textContent = text('transferred');
          }
          if (focus) {
            const firstUnanswered = [...builder.querySelectorAll('[data-builder-question]')].find(question => !question.querySelector('input:checked'));
            const focusTarget = firstUnanswered?.querySelector('input') || builder.querySelector('[data-builder-area]');
            if (focusTarget) focusTarget.focus({ preventScroll: true });
            builder.scrollIntoView({ block: 'start', behavior: 'instant' });
          }
          return true;
        };
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-system-group] input')) return;
          update();
          if (this.hasTransferred) transferToBuilder(false);
        });
        handoff?.addEventListener('click', event => {
          if (transferToBuilder(true)) event.preventDefault();
        });
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-hot-water-choice"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-hot-water-choice'))customElements.define('tl-hot-water-choice',class extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();this.tabs=[...this.querySelectorAll('[data-water-tab]')];this.panels=[...this.querySelectorAll('[data-water-panel]')];if(!this.tabs.length||this.tabs.length!==this.panels.length)return;this.motion=matchMedia('(prefers-reduced-motion:reduce)');const nav=this.querySelector('[data-water-tabs]');nav.hidden=false;nav.setAttribute('role','tablist');this.tabs.forEach((tab,index)=>{tab.setAttribute('role','tab');tab.addEventListener('click',()=>this.select(index),{signal:this.abort.signal});tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;else if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.tabs.length-1;else return;event.preventDefault();this.select(next);this.tabs[next].focus({preventScroll:true})},{signal:this.abort.signal})});this.panels.forEach((panel,index)=>{panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',this.tabs[index].id)});this.motion.addEventListener('change',()=>{if(this.motion.matches)this.animation?.cancel()},{signal:this.abort.signal});this.select(0,false)}
 select(index,animate=true){this.animation?.cancel();this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index});if(animate&&!this.motion.matches){this.animation=this.panels[index].querySelector('figure').animate([{opacity:.65},{opacity:1}],{duration:180,easing:'ease-out'})}}
 disconnectedCallback(){this.abort?.abort();this.abort=null;this.animation?.cancel()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-manual-atlas"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-manual-atlas')) customElements.define('tl-manual-atlas', class extends HTMLElement {
 connectedCallback() {
  if (this.controller && !this.controller.signal.aborted) return;
  this.controller = new AbortController();
  const options = {signal: this.controller.signal};
  this.tabs = [...this.querySelectorAll('[data-atlas-tab]')];
  this.panels = [...this.querySelectorAll('[data-atlas-panel]')];
  if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
  this.motion = matchMedia('(prefers-reduced-motion: reduce)');
  const tabs = this.querySelector('[data-atlas-tabs]');
  tabs.hidden = false;
  tabs.setAttribute('role', 'tablist');
  this.tabs.forEach((tab, index) => {
   tab.setAttribute('role', 'tab');
   tab.addEventListener('click', () => this.select(index), options);
   tab.addEventListener('keydown', event => {
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = this.tabs.length - 1;
    else return;
    event.preventDefault();
    this.select(next);
    this.tabs[next].focus();
   }, options);
  });
  this.panels.forEach((panel, index) => {
   panel.setAttribute('role', 'tabpanel');
   panel.setAttribute('aria-labelledby', this.tabs[index].id);
  });
  this.motion.addEventListener('change', () => { if (this.motion.matches) this.cancelMotion(); }, options);
  window.addEventListener('resize', () => this.cancelMotion(), options);
  const initial = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
  this.active = null;
  this.select(initial < 0 ? 0 : initial, false);
 }
 cancelMotion() {
  this.activeAnimation?.cancel();
  this.activeAnimation = null;
 }
 select(index, motion = true) {
  if (!Number.isInteger(index) || !this.panels[index] || this.active === index) return;
  this.cancelMotion();
  this.active = index;
  this.tabs.forEach((tab, i) => {
   tab.setAttribute('aria-selected', String(i === index));
   tab.tabIndex = i === index ? 0 : -1;
   this.panels[i].hidden = i !== index;
  });
  const image = this.panels[index].querySelector('figure img');
  if (motion && !this.motion.matches && image?.complete && image.naturalWidth && image.animate) {
   const animation = image.animate([{opacity: .92}, {opacity: 1}], {duration: 160, easing: 'ease-out'});
   this.activeAnimation = animation;
   animation.addEventListener('finish', () => { if (this.activeAnimation === animation) this.activeAnimation = null; }, {once: true});
  }
 }
 disconnectedCallback() {
  this.controller?.abort();
  this.cancelMotion();
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-oem-sample-evidence"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-oem-sample-evidence')) {
  customElements.define('tl-oem-sample-evidence', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.controls = this.querySelector('[data-sample-controls]');
      this.steps = [...this.querySelectorAll('[data-sample-step]')];
      this.records = [...this.querySelectorAll('[data-sample-record]')];
      this.checks = [...this.querySelectorAll('[data-sample-check]')];
      if (!this.controls || !this.steps.length || this.steps.length !== this.records.length) return;
      this.bound = true;
      this.animations = new Set();
      this.link = this.querySelector('[data-sample-quote]');
      this.baseHref = this.link?.href;
      this.controls.hidden = false;
      this.controls.setAttribute('role', 'tablist');
      this.steps.forEach((step, i) => {
        step.setAttribute('role', 'tab');
        this.records[i].setAttribute('role', 'tabpanel');
        this.records[i].setAttribute('aria-labelledby', step.id);
      });
      this.dataset.enhanced = 'true';
      this.querySelector('[data-sample-summary]').hidden = false;
      this.onClick = event => {
        const step = event.target.closest('[data-sample-step]');
        if (step && this.controls.contains(step)) this.select(Number(step.dataset.sampleStep), false);
      };
      this.onKey = event => {
        const current = event.target.closest('[data-sample-step]');
        if (!current || !this.controls.contains(current)) return;
        let index = Number(current.dataset.sampleStep);
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') index = (index + 1) % this.steps.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') index = (index + this.steps.length - 1) % this.steps.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.steps.length - 1;
        else return;
        event.preventDefault();
        this.select(index, true);
      };
      this.onChange = event => { if (event.target.matches('[data-sample-check]')) this.updateSummary(); };
      this.onBlock = event => {
        const record = event.target.closest('[data-sample-record]');
        if (record && this.contains(record)) this.select(Number(record.dataset.sampleRecord), false);
      };
      this.onVisibility = () => { if (document.hidden) this.cancelMotion(); };
      this.onPageShow = () => this.updateSummary();
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.addEventListener('change', this.onChange);
      document.addEventListener('shopify:block:select', this.onBlock);
      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('pageshow', this.onPageShow);
      this.select(0, false);
      this.updateSummary();
    }
    select(index, focus) {
      if (!Number.isInteger(index) || !this.records[index]) return;
      const changed = this.active !== index;
      this.cancelMotion();
      this.active = index;
      this.steps.forEach((step, i) => {
        step.setAttribute('aria-selected', String(i === index));
        step.tabIndex = i === index ? 0 : -1;
        this.records[i].hidden = i !== index;
      });
      if (focus) this.steps[index].focus();
      if (changed && !window.Shopify?.designMode && !matchMedia('(prefers-reduced-motion: reduce)').matches && this.records[index].animate) {
        const motion = this.records[index].animate([{ opacity: .85 }, { opacity: 1 }], { duration: 180, easing: 'cubic-bezier(.2,.65,.3,1)' });
        this.animations.add(motion);
        motion.onfinish = () => this.animations.delete(motion);
        motion.oncancel = () => this.animations.delete(motion);
      }
    }
    updateSummary() {
      const selected = this.checks.filter(check => check.checked);
      const labels = selected.map(check => this.records[Number(check.dataset.sampleCheck)].querySelector('h3').textContent.trim());
      const count = this.querySelector('[data-sample-count]');
      count.textContent = this.dataset.countPattern.replaceAll('__DONE__', String(selected.length)).replaceAll('__TOTAL__', String(this.checks.length));
      this.steps.forEach((step, i) => { step.querySelector('.tl-oem-sample__ready').hidden = !this.checks[i].checked; });
      const list = this.querySelector('[data-sample-selected]');
      list.replaceChildren(...labels.map(label => { const item = document.createElement('li'); item.textContent = label; return item; }));
      list.hidden = !labels.length;
      this.querySelector('[data-sample-empty]').hidden = Boolean(labels.length);
      if (!this.link || !this.baseHref) return;
      const target = new URL(this.baseHref, location.href);
      if (target.origin !== location.origin || !target.pathname.endsWith('/pages/request-quote')) return;
      const heading = this.querySelector('h2').textContent.trim();
      target.searchParams.set('source_page', location.pathname);
      target.searchParams.set('brief', heading + (labels.length ? '\n' + this.dataset.summaryLabel + '\n' + labels.map(label => '• ' + label).join('\n') : ''));
      this.link.href = target.pathname + target.search + target.hash;
    }
    cancelMotion() {
      this.animations?.forEach(motion => motion.cancel());
      this.animations?.clear();
    }
    disconnectedCallback() {
      this.cancelMotion();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.removeEventListener('change', this.onChange);
      document.removeEventListener('shopify:block:select', this.onBlock);
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('pageshow', this.onPageShow);
      this.records?.forEach(record => { record.hidden = false; record.removeAttribute('role'); record.removeAttribute('aria-labelledby'); });
      if (this.controls) this.controls.hidden = true;
      delete this.dataset.enhanced;
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-partner-brief"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('tl-purchase-brief')) {
    customElements.define('tl-purchase-brief', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.routes = [...this.querySelectorAll('.tl-partner-brief__route')];
        this.animations = new Map();
        this.targets = new Map();
        this.link = this.querySelector('[data-scenario-link]');
        this.originalHref = this.link?.href;
        this.routes.forEach(route => {
          route.querySelector('summary').addEventListener('click', event => {
            event.preventDefault();
            const shouldOpen = !(this.targets.get(route) ?? route.open);
            this.routes.forEach(item => this.setOpen(item, item === route && shouldOpen));
            this.setContext(shouldOpen ? route : null);
          }, {signal: this.controller.signal});
        });
        this.motion.addEventListener('change', () => {
          if (!this.motion.matches) return;
          this.routes.forEach(route => this.setOpen(route, this.targets.get(route) ?? route.open, true));
        }, {signal: this.controller.signal});
      }
      setOpen(route, open, immediate = false) {
        const start = route.getBoundingClientRect().height;
        this.animations.get(route)?.cancel();
        this.targets.set(route, open);
        if (immediate || this.motion.matches || !route.animate) { route.open = open; route.style.overflow = ''; return; }
        const hadOpen = route.open;
        route.open = true;
        const end = open ? route.getBoundingClientRect().height : route.querySelector('summary').getBoundingClientRect().height + 1;
        if (!hadOpen && !open) { route.open = false; return; }
        route.style.overflow = 'hidden';
        const animation = route.animate([{height: start + 'px'}, {height: end + 'px'}], {duration: 320, easing: 'cubic-bezier(.2,.65,.3,1)'});
        this.animations.set(route, animation);
        animation.onfinish = () => { route.open = open; route.style.overflow = ''; this.animations.delete(route); };
      }
      setContext(route) {
        const status = this.querySelector('[data-scenario-status]');
        const label = this.querySelector('[data-scenario-label]')?.textContent.trim() || '';
        const selected = this.querySelector('[data-selected-scenario]');
        const title = route?.querySelector('[data-scenario-title]')?.textContent.trim() || '';
        if (status && selected) {
          status.hidden = !route;
          selected.textContent = title;
          if (route && !this.motion.matches && status.animate) status.animate([{translate: '0 12px', opacity: .4}, {translate: '0 0', opacity: 1}], {duration: 320, easing: 'ease-out'});
        }
        if (this.link && this.originalHref) {
          const url = new URL(this.originalHref, location.href);
          if (route && url.origin === location.origin) url.searchParams.set('brief', [label, title].filter(Boolean).join(': '));
          this.link.href = route ? url.href : this.originalHref;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.animations?.forEach(a => a.cancel());
        this.routes?.forEach(route => { route.open = this.targets.get(route) ?? route.open; route.style.overflow = ''; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-product-dossier"] && !Shopify.designMode) return;
  try {
    
(()=>{
if(window.TaillaiDossier){window.TaillaiDossier.mount(document);return}
const instances=new Map();
const mount=root=>{const sections=[...root.querySelectorAll('[data-product-dossier]')];if(root.matches?.('[data-product-dossier]'))sections.unshift(root);sections.forEach(section=>{if(instances.has(section))return;const abort=new AbortController(),signal=abort.signal;const targetOf=hash=>{let id;try{id=decodeURIComponent(hash.slice(1))}catch{return null}const target=document.getElementById(id);return target&&section.contains(target)&&target.tagName==='DETAILS'?target:null};const openHash=()=>{const d=targetOf(location.hash);if(d)d.open=true};openHash();addEventListener('hashchange',openHash,{signal});document.addEventListener('click',event=>{const link=event.target.closest('a[href^="#"]');const d=link&&targetOf(link.hash);if(d)d.open=true},{signal});instances.set(section,abort)})};
const unmount=root=>instances.forEach((abort,section)=>{if(root===document||root===section||root.contains(section)){abort.abort();instances.delete(section)}});
window.TaillaiDossier=Object.freeze({mount,unmount});document.addEventListener('shopify:section:load',e=>mount(e.target));document.addEventListener('shopify:section:unload',e=>unmount(e.target));addEventListener('pagehide',()=>unmount(document));addEventListener('pageshow',e=>{if(e.persisted)mount(document)});mount(document)
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-product-focus"] && !Shopify.designMode) return;
  try {
    
(() => {
  const key = '__taillaiProductFocusMotion';
  if (window[key]) {
    window[key].initialize();
    return;
  }
  const instances = new WeakMap();
  const sectionsWithin = root => [...(root.matches?.('[data-product-focus]') ? [root] : []), ...root.querySelectorAll('[data-product-focus]')];
  const initialize = (root = document) => sectionsWithin(root).forEach(section => {
    if (instances.has(section)) return;
    const controls = section.querySelector('[data-focus-controls]');
    const stage = section.querySelector('[data-focus-panels]');
    const status = section.querySelector('[data-focus-status]');
    const panels = [...section.querySelectorAll('[data-focus-panel]')];
    const buttons = [...section.querySelectorAll('[data-focus-target]')];
    if (!stage || !status || !panels.length) return;
    if (panels.length === 1 && section.dataset.focusMode === 'control_only') {
      const lifecycle = new AbortController();
      const panel = panels[0];
      const image = panel.querySelector('img');
      const error = panel.querySelector('[data-focus-image-error]');
      const onError = () => {
        panel.classList.add('is-image-error');
        if (error) error.hidden = false;
        status.hidden = false;
        status.textContent = status.dataset.errorLabel;
      };
      const onLoad = () => {
        panel.classList.remove('is-image-error');
        if (error) error.hidden = true;
        status.hidden = true;
        status.textContent = '';
      };
      if (image) {
        image.addEventListener('error', onError, { signal: lifecycle.signal });
        image.addEventListener('load', onLoad, { signal: lifecycle.signal });
        if (image.complete && !image.naturalWidth) onError();
      }
      stage.setAttribute('aria-busy', 'false');
      section.dataset.enhanced = 'static';
      instances.set(section, () => {
        lifecycle.abort();
        delete section.dataset.enhanced;
        instances.delete(section);
      });
      return;
    }
    if (!controls || panels.length !== buttons.length || !buttons.length) return;
    const lifecycle = new AbortController();
    const signal = lifecycle.signal;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const indicator = document.createElement('span');
    indicator.className = 'tl-focus__indicator';
    indicator.setAttribute('aria-hidden', 'true');
    indicator.setAttribute('inert', '');
    controls.prepend(indicator);
    let imageAnimations = [];
    let indicatorAnimation;
    let ghost;
    let selected = 0;
    let visible = 0;
    let requestToken = 0;
    let cancelWait;
    let indicatorReady = false;
    const motionAllowed = () => !reduced.matches && !document.hidden && !signal.aborted;
    const clearImages = () => {
      imageAnimations.forEach(animation => animation.cancel());
      imageAnimations = [];
      ghost?.remove();
      ghost = undefined;
    };
    const positionIndicator = (animate = false) => {
      if (signal.aborted) return;
      const previous = indicator.getBoundingClientRect();
      indicatorAnimation?.cancel();
      indicatorAnimation = undefined;
      const target = buttons[selected].getBoundingClientRect();
      const parent = controls.getBoundingClientRect();
      const left = target.left - parent.left;
      const top = target.top - parent.top;
      indicator.style.left = `${left}px`;
      indicator.style.top = `${top}px`;
      indicator.style.width = `${target.width}px`;
      indicator.style.height = `${target.height}px`;
      if (animate && indicatorReady && motionAllowed() && indicator.animate && previous.width && target.width) {
        const sameRow = Math.abs(previous.top - target.top) < 2;
        const frames = sameRow ? [
          { transform: `translate(${previous.left - target.left}px,0) scale(${previous.width / target.width},${previous.height / target.height})` },
          { transform: 'translate(0,0) scale(1,1)' }
        ] : [
          { opacity: .6, transform: 'scale(.985)' },
          { opacity: 1, transform: 'scale(1)' }
        ];
        indicatorAnimation = indicator.animate(frames, { duration: sameRow ? 340 : 220, easing: 'cubic-bezier(.2,.8,.2,1)' });
        indicatorAnimation.finished.catch(() => {});
      }
      indicatorReady = true;
    };
    const stopMotion = () => {
      section.classList.toggle('is-motion-still', reduced.matches || document.hidden);
      clearImages();
      positionIndicator(false);
    };
    const readyImage = image => new Promise((resolve, reject) => {
      let finished = false;
      const listeners = new AbortController();
      const finish = error => {
        if (finished) return;
        finished = true;
        listeners.abort();
        window.clearTimeout(timer);
        if (cancelWait === cancel) cancelWait = undefined;
        if (error) reject(error);
        else resolve();
      };
      const cancel = () => finish(new Error('Selection superseded'));
      const timer = window.setTimeout(() => finish(new Error('Image load timeout')), 12000);
      cancelWait = cancel;
      image.loading = 'eager';
      if (typeof image.decode === 'function') {
        image.decode().then(() => {
          if (image.naturalWidth) finish();
          else finish(new Error('Image unavailable'));
        }, error => finish(error));
      } else if (image.complete) {
        finish(image.naturalWidth ? undefined : new Error('Image unavailable'));
      } else {
        image.addEventListener('load', () => finish(), { once: true, signal: listeners.signal });
        image.addEventListener('error', () => finish(new Error('Image unavailable')), { once: true, signal: listeners.signal });
      }
    });
    const commit = (index, animate) => {
      const previous = panels[visible].querySelector('.tl-focus__image');
      const previousBox = previous.getBoundingClientRect();
      const stageBox = stage.getBoundingClientRect();
      let outgoing;
      if (animate && index !== visible && motionAllowed() && previous.animate && previousBox.bottom > 0 && previousBox.top < window.innerHeight) {
        outgoing = document.createElement('div');
        outgoing.className = 'tl-focus__ghost';
        outgoing.setAttribute('aria-hidden', 'true');
        outgoing.setAttribute('inert', '');
        const copy = previous.cloneNode(true);
        [copy, ...copy.querySelectorAll('*')].forEach(item => {
          [...item.attributes].forEach(attribute => {
            if (attribute.name === 'id' || attribute.name === 'href' || attribute.name === 'tabindex' || attribute.name === 'target' || attribute.name === 'rel' || attribute.name.startsWith('aria-') || attribute.name.startsWith('data-focus')) item.removeAttribute(attribute.name);
          });
          if (item.tagName === 'IMG') item.alt = '';
        });
        copy.querySelectorAll('.tl-focus__image-kind,.tl-focus__image-open,.tl-focus__image-error').forEach(item => item.remove());
        const copiedImage = copy.querySelector('img');
        const originalImage = previous.querySelector('img');
        if (copiedImage && originalImage) copiedImage.style.objectPosition = getComputedStyle(originalImage).objectPosition;
        copy.style.width = `${previousBox.width}px`;
        copy.style.height = `${previousBox.height}px`;
        outgoing.append(copy);
      }
      visible = index;
      panels.forEach((item, position) => { item.hidden = position !== index; });
      const incoming = panels[index].querySelector('.tl-focus__image');
      if (!outgoing) return;
      const incomingBox = incoming.getBoundingClientRect();
      outgoing.style.left = `${previousBox.left - stageBox.left}px`;
      outgoing.style.top = `${previousBox.top - stageBox.top}px`;
      outgoing.style.width = `${Math.min(previousBox.width, incomingBox.width)}px`;
      outgoing.style.height = `${Math.min(previousBox.height, incomingBox.height)}px`;
      stage.append(outgoing);
      ghost = outgoing;
      const timing = { duration: 460, easing: 'cubic-bezier(.2,.8,.2,1)' };
      const entering = incoming.animate([
        { opacity: .72, transform: 'translateY(8px) scale(.985)' },
        { opacity: 1, transform: 'translateY(0) scale(1)' }
      ], timing);
      const leaving = outgoing.animate([{ opacity: 1 }, { opacity: 0 }], timing);
      const exiting = outgoing.firstElementChild.animate([
        { transform: 'translateY(0) scale(1)' },
        { transform: 'translateY(-6px) scale(1.015)' }
      ], timing);
      imageAnimations = [entering, leaving, exiting];
      leaving.finished.then(() => {
        if (ghost === outgoing) {
          outgoing.remove();
          ghost = undefined;
          imageAnimations = [];
        }
      }).catch(() => {});
      entering.finished.catch(() => {});
      exiting.finished.catch(() => {});
    };
    const show = async (index, animate = true) => {
      const panel = panels[index];
      const image = panel?.querySelector('img');
      if (!panel || !image || signal.aborted) return;
      const token = ++requestToken;
      if (cancelWait) cancelWait();
      clearImages();
      selected = index;
      buttons.forEach((button, position) => button.setAttribute('aria-pressed', String(position === index)));
      positionIndicator(animate);
      if (index === visible && image.complete && image.naturalWidth && !panel.classList.contains('is-image-error')) {
        stage.setAttribute('aria-busy', 'false');
        status.hidden = true;
        status.textContent = '';
        return;
      }
      stage.setAttribute('aria-busy', 'true');
      status.hidden = false;
      status.textContent = status.dataset.loadingLabel;
      try {
        await readyImage(image);
        if (token !== requestToken || signal.aborted) return;
        panel.classList.remove('is-image-error');
        panel.querySelector('[data-focus-image-error]').hidden = true;
        status.hidden = true;
        status.textContent = '';
        commit(index, animate);
      } catch (error) {
        if (token !== requestToken || signal.aborted) return;
        panel.classList.add('is-image-error');
        panel.querySelector('[data-focus-image-error]').hidden = false;
        status.hidden = false;
        status.textContent = status.dataset.errorLabel;
        commit(index, false);
      } finally {
        if (token === requestToken && !signal.aborted) stage.setAttribute('aria-busy', 'false');
      }
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => { show(index); }, { signal });
      button.addEventListener('keydown', event => {
        let target = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = (index - 1 + buttons.length) % buttons.length;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = buttons.length - 1;
        else return;
        event.preventDefault();
        buttons[target].focus();
        show(target);
      }, { signal });
    });
    reduced.addEventListener('change', stopMotion, { signal });
    document.addEventListener('visibilitychange', stopMotion, { signal });
    const observer = new ResizeObserver(() => positionIndicator(false));
    observer.observe(controls);
    const cleanup = () => {
      ++requestToken;
      if (cancelWait) cancelWait();
      clearImages();
      indicatorAnimation?.cancel();
      observer.disconnect();
      lifecycle.abort();
      section.classList.add('is-motion-still');
      indicator.remove();
      controls.classList.remove('is-pill-ready');
      controls.hidden = true;
      panels.forEach(panel => { panel.hidden = false; });
      stage.setAttribute('aria-busy', 'false');
      status.hidden = true;
      status.textContent = '';
      delete section.dataset.enhanced;
      instances.delete(section);
    };
    instances.set(section, cleanup);
    section.dataset.enhanced = 'true';
    section.classList.toggle('is-motion-still', reduced.matches || document.hidden);
    controls.hidden = false;
    positionIndicator(false);
    controls.classList.add('is-pill-ready');
    document.fonts?.ready.then(() => positionIndicator(false));
    panels.forEach((panel, index) => { panel.hidden = index !== visible; });
    show(selected, false);
  });
  window[key] = { initialize };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => sectionsWithin(event.target).forEach(section => instances.get(section)?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-product-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-product-detail')) {
    customElements.define('tl-product-detail', class extends HTMLElement {
      connectedCallback() {
        if (this.stopEvents) return;
        const abort = new AbortController();
        this.stopEvents = abort;
        const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const image = this.querySelector('.tl-product-detail__image');
        const slot = this.querySelector('[data-product-nav-slot]');
        const links = [...this.querySelectorAll('[data-product-jump]')];
        const targets = links.map(link => document.getElementById(link.hash.slice(1)));
        const header = document.querySelector('.tl-header');
        const update = () => {
          this.frame = null;
          if (document.hidden) return;
          const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 76;
          const offset = Math.min(150, headerBottom + 8);
          const rootInset = parseFloat(window.getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
          this.style.setProperty('--product-nav-top', `${offset}px`);
          if (slot) this.dataset.navDocked = String(slot.getBoundingClientRect().top < offset);
          let active = 0;
          targets.forEach((target, index) => {
            if (!target) return;
            const targetInset = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
            const activationLine = Math.max(offset + 150, rootInset + targetInset + 2);
            if (target.getBoundingClientRect().top <= activationLine) active = index;
          });
          links.forEach((link, index) => {
            if (index === active) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
          if (!image) return;
          if (preference.matches || window.innerWidth < 700) {
            image.style.removeProperty('--product-shift');
            return;
          }
          const bounds = this.getBoundingClientRect();
          if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;
          const progress = (window.innerHeight * .5 - bounds.top) / Math.max(bounds.height, 1);
          const shift = Math.max(-10, Math.min(10, (progress - .35) * 36));
          image.style.setProperty('--product-shift', `${shift.toFixed(2)}px`);
        };
        const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
        window.addEventListener('scroll', schedule, { passive: true, signal: abort.signal });
        window.addEventListener('resize', schedule, { passive: true, signal: abort.signal });
        window.addEventListener('hashchange', schedule, { signal: abort.signal });
        document.addEventListener('visibilitychange', schedule, { signal: abort.signal });
        preference.addEventListener('change', schedule, { signal: abort.signal });
        update();
      }
      disconnectedCallback() {
        this.stopEvents?.abort();
        this.stopEvents = null;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-product-nav"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-product-nav'))customElements.define('tl-product-nav',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.frame=0;this.links=[...this.querySelectorAll('.tl-product-nav__links a')];this.targets=this.links.map(a=>document.getElementById(decodeURIComponent(a.hash.slice(1))));this.update=()=>{this.frame=0;if(!this.isConnected||document.hidden)return;const edge=this.getBoundingClientRect().bottom+72;let active=-1;this.targets.forEach((t,i)=>{if(t&&t.getBoundingClientRect().top<=edge)active=i});this.links.forEach((a,i)=>{if(i===active)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current')})};this.schedule=()=>{if(!this.frame&&!document.hidden)this.frame=requestAnimationFrame(this.update)};addEventListener('scroll',this.schedule,{passive:true,signal});addEventListener('resize',this.schedule,{passive:true,signal});document.addEventListener('visibilitychange',()=>{if(document.hidden&&this.frame){cancelAnimationFrame(this.frame);this.frame=0}else this.size=new ResizeObserver(()=>{document.documentElement.style.setProperty('--tl-product-nav-height',`${Math.ceil(this.getBoundingClientRect().height)+2}px`);this.schedule()});this.size.observe(this);this.schedule()},{signal});this.size=new ResizeObserver(()=>{document.documentElement.style.setProperty('--tl-product-nav-height',`${Math.ceil(this.getBoundingClientRect().height)+2}px`);this.schedule()});this.size.observe(this);this.schedule()}
disconnectedCallback(){this.abort?.abort();this.size?.disconnect();document.documentElement.style.removeProperty('--tl-product-nav-height');if(this.frame)cancelAnimationFrame(this.frame);this.abort=null;this.frame=0}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-product-parameters"] && !Shopify.designMode) return;
  try {
    
(()=>{
if(window.TaillaiParameters){window.TaillaiParameters.mount(document);return}
const instances=new Map();
const mount=root=>{
  instances.forEach((state,section)=>{if(!section.isConnected){state.abort.abort();state.disclosures.forEach(cleanup=>cleanup());state.restoreBenefits();state.restoreQuoteLinks();instances.delete(section)}});
  const sections=[...root.querySelectorAll('[data-product-parameters]')];
  if(root.matches?.('[data-product-parameters]'))sections.unshift(root);
  sections.forEach(section=>{
    if(instances.has(section))return;
    const controls=section.querySelector('[data-parameter-controls]'),typeSelect=section.querySelector('[data-parameter-type-select]'),powerSelect=section.querySelector('[data-parameter-power-select]'),all=section.querySelector('[data-parameter-all]'),benefitsSlot=section.querySelector('[data-parameter-benefits-slot]');
    const tables=new Map(),benefitGroups=new Map(),quoteLinks=new Map();
    const story=section.dataset.presentation==='story',quote=section.querySelector('[data-parameter-quote]');
    if(story)document.querySelectorAll('.tl-stage__primary[href*="/pages/request-quote"],a[data-product-enquiry][href*="/pages/request-quote"],[data-product-enquiry] a[href*="/pages/request-quote"]').forEach(link=>quoteLinks.set(link,link.getAttribute('href')));
    section.querySelectorAll('[data-parameter-table]').forEach(table=>{
      const headings=Object.fromEntries([...table.querySelectorAll('[data-parameter-heading]')].map(cell=>[cell.dataset.parameterHeading,cell.textContent.trim()]));
      const rows=[...table.querySelectorAll('[data-parameter-record]')].map(row=>({power:row.dataset.power,cells:Object.fromEntries([...row.querySelectorAll('[data-parameter-cell]')].map(cell=>[cell.dataset.parameterCell,cell.textContent.trim()]))}));
      if(rows.length)tables.set(table.dataset.parameterTable,{headings,rows});
    });
    section.querySelectorAll('[data-parameter-benefits-home]').forEach(home=>{
      const group=home.querySelector('[data-parameter-benefits]');
      if(group)benefitGroups.set(home.dataset.parameterBenefitsHome,{group,home,details:home.closest('[data-parameter-type-details]')});
    });
    if(!controls||!typeSelect||!powerSelect||!all||tables.size!==4)return;
    const abort=new AbortController(),signal=abort.signal,reduced=matchMedia('(prefers-reduced-motion: reduce)');
    let slotAnimation,groupAnimation;
    const stopStoryMotion=()=>{
      slotAnimation?.cancel();groupAnimation?.cancel();slotAnimation=undefined;groupAnimation=undefined;
      if(benefitsSlot){benefitsSlot.style.removeProperty('overflow');benefitsSlot.style.removeProperty('overflow-anchor')}
    };
    const canAnimate=()=>!reduced.matches&&!document.hidden&&typeof benefitsSlot?.animate==='function';
    const restoreBenefits=()=>{
      stopStoryMotion();benefitGroups.forEach(({group,home})=>{if(group.parentElement!==home)home.append(group);group.classList.remove('tl-parameter-benefits--active');home.hidden=false});
      if(benefitsSlot)benefitsSlot.hidden=true;
    };
    const showBenefits=(animate=false)=>{
      if(!benefitsSlot)return;
      const selected=benefitGroups.get(typeSelect.value),changed=selected?.group.parentElement!==benefitsSlot;
      if(!changed)return;
      const from=benefitsSlot.getBoundingClientRect().height;
      stopStoryMotion();
      benefitGroups.forEach(({group,home})=>{
        home.hidden=true;
        if(group!==selected?.group){if(group.parentElement!==home)home.append(group);group.classList.remove('tl-parameter-benefits--active')}
      });
      benefitsSlot.hidden=!selected;
      if(!selected)return;
      benefitsSlot.append(selected.group);selected.group.classList.add('tl-parameter-benefits--active');
      if(!animate||!canAnimate()||!from)return;
      const to=benefitsSlot.getBoundingClientRect().height;
      benefitsSlot.style.overflow='clip';benefitsSlot.style.overflowAnchor='none';
      slotAnimation=benefitsSlot.animate([{height:from+'px'},{height:to+'px'}],{duration:320,easing:'cubic-bezier(.2,.8,.2,1)',fill:'both'});
      const running=slotAnimation;
      running.onfinish=()=>{if(slotAnimation===running){running.cancel();slotAnimation=undefined;benefitsSlot.style.removeProperty('overflow');benefitsSlot.style.removeProperty('overflow-anchor')}};
      groupAnimation=selected.group.animate([{opacity:.55,transform:'translateY(4px)'},{opacity:1,transform:'translateY(0)'}],{duration:240,easing:'cubic-bezier(.2,.8,.2,1)'});
      const entering=groupAnimation;
      entering.onfinish=()=>{if(groupAnimation===entering)groupAnimation=undefined};
    };
    const restoreQuoteLinks=()=>quoteLinks.forEach((href,link)=>{if(link.isConnected)link.setAttribute('href',href)});
    const quoteBrief=(type,power)=>section.dataset.quoteBrief?.replaceAll('__TYPE__',type).replaceAll('__POWER__',power)||'';
    const updateQuotes=(type,power)=>{
      if(!story)return;
      const brief=quoteBrief(type,power);
      if(quote){const url=new URL(quote.href,location.origin);url.searchParams.set('brief',brief);quote.setAttribute('href',url.pathname+url.search)}
      if(section.dataset.userSelection==='true')quoteLinks.forEach((original,link)=>{if(link.isConnected){const url=new URL(original,location.origin);url.searchParams.set('brief',brief);link.setAttribute('href',url.pathname+url.search)}});
    };
    const set=(key,value)=>{const target=section.querySelector('[data-parameter-selected-'+key+']');if(target)target.textContent=value};
    const update=(animate=false)=>{
      const table=tables.get(typeSelect.value),record=table?.rows.find(row=>row.power===powerSelect.value);
      if(!record)return;
      set('type',typeSelect.selectedOptions[0].textContent.trim());set('power',record.cells.power);set('gas',record.cells.gas);
      ['input','output','dhw'].forEach(key=>{set(key+'-label',table.headings[key]);set(key,record.cells[key])});
      set('configuration',[section.dataset.quoteModel,typeSelect.selectedOptions[0].textContent.trim(),record.cells.power].filter(Boolean).join(' · '));
      updateQuotes(typeSelect.selectedOptions[0].textContent.trim(),record.cells.power);
      showBenefits(animate);
    };
    const setPowers=(preferred,animate=false)=>{
      const table=tables.get(typeSelect.value);if(!table)return;
      powerSelect.replaceChildren(...table.rows.map(row=>{const option=document.createElement('option');option.value=row.power;option.textContent=row.cells.power;return option}));
      powerSelect.value=table.rows.some(row=>row.power===preferred)?preferred:table.rows[0].power;
      update(animate);
    };
    const selectBlock=(blockId,target)=>{
      let selected;
      benefitGroups.forEach((entry,type)=>{
        const blocks=[...entry.group.querySelectorAll('[data-parameter-benefit-block]')];
        if(blocks.some(block=>block.dataset.parameterBenefitBlock===blockId||block===target||block.contains(target)))selected=type;
      });
      if(!selected)return;
      typeSelect.value=selected;setPowers(powerSelect.value);
    };
    const preferredType=section.dataset.selectedType||section.dataset.initialType;
    typeSelect.value=tables.has(preferredType)?preferredType:typeSelect.options[0].value;
    setPowers(section.dataset.selectedPower||section.dataset.initialPower);
    const rememberSelection=()=>{section.dataset.userSelection='true';section.dataset.selectedType=typeSelect.value;section.dataset.selectedPower=powerSelect.value};
    typeSelect.addEventListener('change',()=>{section.dataset.userSelection='true';setPowers(powerSelect.value,true);rememberSelection()},{signal});
    powerSelect.addEventListener('change',()=>{rememberSelection();update()},{signal});
    reduced.addEventListener('change',stopStoryMotion,{signal});addEventListener('resize',stopStoryMotion,{signal});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)stopStoryMotion()},{signal});
    controls.hidden=false;all.open=false;showBenefits();
    const disclosures=[...section.querySelectorAll('details')].map(details=>window.TaillaiDisclosureMotion?.attach(details,details===all?{onChange:open=>{if(open){const selected=benefitGroups.get(typeSelect.value);if(selected?.details){if(window.TaillaiDisclosureMotion?.setOpen)window.TaillaiDisclosureMotion.setOpen(selected.details,true,{animate:false});else selected.details.open=true}}}}:{})).filter(Boolean);
    instances.set(section,{abort,controls,all,restoreBenefits,restoreQuoteLinks,selectBlock,disclosures});
  });
};
const unmount=root=>instances.forEach((state,section)=>{if(root===document||root===section||root.contains(section)){state.abort.abort();state.disclosures.forEach(cleanup=>cleanup());state.restoreBenefits();state.restoreQuoteLinks();state.controls.hidden=true;state.all.open=true;instances.delete(section)}});
window.TaillaiParameters=Object.freeze({mount,unmount});document.addEventListener('shopify:section:load',event=>mount(event.target));document.addEventListener('shopify:section:unload',event=>unmount(event.target));document.addEventListener('shopify:block:select',event=>instances.forEach(state=>state.selectBlock(event.detail?.blockId,event.target)));addEventListener('pagehide',()=>unmount(document));addEventListener('pageshow',event=>{if(event.persisted)mount(document)});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-product-proof"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.TaillaiProductFilms) {
    window.TaillaiProductFilms.mount(document);
    return;
  }
  const instances = new Map();
  const mount = root => {
    instances.forEach((destroy, film) => {
      if (!film.isConnected) {
        destroy();
        instances.delete(film);
      }
    });
    const films = [...root.querySelectorAll('[data-product-film],.tl-product-proof__source')];
    if (root.matches?.('[data-product-film],.tl-product-proof__source')) films.unshift(root);
    films.forEach(film => {
      if (instances.has(film)) return;
      const video = film.querySelector('video');
      const error = film.querySelector('[data-product-film-error]');
      const onToggle = () => {
        if (!film.open) video?.pause();
      };
      const onError = () => {
        if (error) error.hidden = false;
      };
      const onReady = () => {
        if (error) error.hidden = true;
      };
      const releaseMotion = window.TaillaiDisclosureMotion?.attach(film, { onChange: open => { if (!open) video?.pause(); } });
      film.addEventListener('toggle', onToggle);
      video?.addEventListener('error', onError, true);
      video?.addEventListener('loadeddata', onReady);
      instances.set(film, () => {
        releaseMotion?.();
        video?.pause();
        film.removeEventListener('toggle', onToggle);
        video?.removeEventListener('error', onError, true);
        video?.removeEventListener('loadeddata', onReady);
      });
    });
  };
  const unmount = root => {
    instances.forEach((destroy, film) => {
      if (root === document || root === film || root.contains(film) || !film.isConnected) {
        destroy();
        instances.delete(film);
      }
    });
  };
  const pause = () => instances.forEach((destroy, film) => film.querySelector('video')?.pause());
  window.TaillaiProductFilms = { mount, unmount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => unmount(event.target));
  document.addEventListener('visibilitychange', () => { if (document.hidden) pause(); });
  addEventListener('pagehide', () => unmount(document));
  addEventListener('pageshow', event => { if (event.persisted) mount(document); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-product-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-showcase-browse')) customElements.define('tl-showcase-browse', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.grid = this.closest('.tl-showcase').querySelector('.tl-showcase__grid');
      this.cards = [...this.grid.querySelectorAll('.tl-showcase__item')];
      this.buttons = [...this.querySelectorAll('button')];
      this.count = this.querySelector('.tl-showcase-browse__count');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.targetIndex = null;
      this.currentIndex = 0;
      this.update = () => {
        const limit = this.grid.scrollWidth - this.grid.clientWidth;
        this.hidden = limit < 4;
        this.buttons[0].disabled = this.grid.scrollLeft < 4;
        this.buttons[1].disabled = this.grid.scrollLeft >= limit - 4;
        const edge = this.grid.getBoundingClientRect().left;
        let nearest = 0;
        this.cards.forEach((card, i) => { if (Math.abs(card.getBoundingClientRect().left - edge) < Math.abs(this.cards[nearest].getBoundingClientRect().left - edge)) nearest = i; });
        this.currentIndex = nearest;
        if (this.targetIndex !== null) {
          this.buttons[0].disabled = this.targetIndex === 0;
          this.buttons[1].disabled = this.targetIndex === this.cards.length - 1;
        }
        this.count.textContent = `${nearest + 1} / ${this.cards.length}`;
      };
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const edge = this.grid.getBoundingClientRect().left;
        const direction = Number(button.dataset.direction);
        const positions = this.cards.map(card => this.grid.scrollLeft + card.getBoundingClientRect().left - edge - 4);
        this.targetIndex = Math.max(0, Math.min(this.cards.length - 1, (this.targetIndex ?? this.currentIndex) + direction));
        this.grid.scrollTo({left: positions[this.targetIndex], behavior: this.motion.matches ? 'instant' : 'smooth'});
        this.update();
      }, {signal}));
      this.grid.addEventListener('scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.update); }, {signal, passive:true});
      this.grid.addEventListener('scrollend', () => { this.targetIndex = null; this.update(); }, {signal});
      this.grid.addEventListener('focusin', event => {
        if (!event.target.matches(':focus-visible') || this.grid.scrollWidth <= this.grid.clientWidth + 4) return;
        const card = event.target.closest('.tl-showcase__item');
        if (!card) return;
        this.targetIndex = null;
        this.grid.scrollTo({left: this.grid.scrollLeft + card.getBoundingClientRect().left - this.grid.getBoundingClientRect().left - 4, behavior: 'instant'});
        this.update();
      }, {signal});
      for (const type of ['pointerdown','touchstart','wheel','keydown']) this.grid.addEventListener(type, () => { this.targetIndex = null; this.update(); }, {signal, passive:true});
      this.motion.addEventListener('change', () => { this.targetIndex = null; this.grid.scrollTo({left:this.grid.scrollLeft, behavior:'instant'}); this.update(); }, {signal});
      this.gridWidth = this.grid.clientWidth;
      this.onResize = () => {
        const width = this.grid.clientWidth;
        if (width !== this.gridWidth) {
          this.gridWidth = width;
          this.targetIndex = null;
          this.grid.scrollTo({left:this.grid.scrollLeft, behavior:'instant'});
        }
        this.update();
      };
      if ('ResizeObserver' in window) { this.resize = new ResizeObserver(this.onResize); this.resize.observe(this.grid); }
      else window.addEventListener('resize', this.onResize, {signal});
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.resize?.disconnect(); cancelAnimationFrame(this.frame); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-product-stage"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.TaillaiStageMotion) {
    window.TaillaiStageMotion.mount(document);
    return;
  }
  const instances = new Map();
  const create = section => {
    const style = section.dataset.stageMotion;
    const visual = section.querySelector('.tl-stage__visual');
    const image = section.querySelector('.tl-stage__image');
    if (style === 'still' || !visual || !image || !('IntersectionObserver' in window)) return null;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = matchMedia('(min-width: 801px)');
    const amplitude = style === 'editorial' ? 22 : 14;
    const scaleAmount = style === 'editorial' ? .025 : .015;
    let visible = false;
    let destroyed = false;
    let listening = false;
    let played = false;
    let waiting = false;
    let animation = null;
    let frame = 0;
    let previousTime = 0;
    let target = 0;
    let current = 0;
    const apply = value => {
      section.style.setProperty('--stage-image-y', `${value.toFixed(3)}px`);
      section.style.setProperty('--stage-image-scale', (1 + Math.abs(value) / amplitude * scaleAmount).toFixed(5));
      section.style.setProperty('--stage-type-y', `${(-value * .45).toFixed(3)}px`);
      section.style.setProperty('--stage-type-opacity', (.09 - Math.abs(value) / amplitude * .02).toFixed(5));
    };
    const stop = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      previousTime = 0;
    };
    const neutral = () => {
      stop();
      target = 0;
      current = 0;
      ['--stage-image-y', '--stage-image-scale', '--stage-type-y', '--stage-type-opacity'].forEach(name => section.style.removeProperty(name));
    };
    const allowed = () => !destroyed && visible && desktop.matches && !reduce.matches && !document.hidden && section.isConnected;
    const step = time => {
      frame = 0;
      if (!allowed()) {
        neutral();
        return;
      }
      const dt = previousTime ? Math.min(48, time - previousTime) : 16.67;
      previousTime = time;
      current += (target - current) * (1 - Math.exp(-dt / 78));
      if (Math.abs(target - current) < .03) {
        current = target;
        previousTime = 0;
        apply(current);
        return;
      }
      apply(current);
      frame = requestAnimationFrame(step);
    };
    const start = () => {
      if (!frame && !animation && allowed() && Math.abs(target - current) >= .03) frame = requestAnimationFrame(step);
    };
    const onScroll = () => {
      if (!allowed()) return;
      const rect = visual.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - rect.top - rect.height / 2) / ((innerHeight + rect.height) / 2)));
      target = progress * amplitude;
      start();
    };
    const syncScroll = () => {
      const next = allowed();
      if (next === listening) return;
      listening = next;
      if (next) addEventListener('scroll', onScroll, { passive: true });
      else removeEventListener('scroll', onScroll);
    };
    const removeLoad = () => {
      image.removeEventListener('load', enter);
      waiting = false;
    };
    const cancelEnter = () => {
      removeLoad();
      if (animation) animation.cancel();
      animation = null;
    };
    const enter = () => {
      removeLoad();
      if (played || destroyed || !visible || reduce.matches || document.hidden || !image.naturalWidth) return;
      played = true;
      if (!image.animate) return;
      const running = image.animate([{ translate: '0 12px', opacity: .82 }, { translate: '0 0px', opacity: 1 }], {
        duration: desktop.matches ? 620 : 480,
        easing: 'cubic-bezier(.22,.75,.25,1)'
      });
      animation = running;
      running.finished.catch(() => {}).finally(() => {
        if (animation === running) animation = null;
        start();
      });
    };
    const tryEnter = () => {
      if (played || destroyed || !visible || reduce.matches || document.hidden) return;
      if (image.complete) enter();
      else if (!waiting) {
        waiting = true;
        image.addEventListener('load', enter, { once: true });
      }
    };
    const refresh = () => {
      cancelEnter();
      neutral();
      syncScroll();
      tryEnter();
    };
    const onVisibility = () => {
      if (document.hidden) {
        cancelEnter();
        neutral();
        syncScroll();
      } else {
        syncScroll();
        tryEnter();
      }
    };
    const observer = new IntersectionObserver(entries => {
      const entry = entries.find(item => item.target === visual);
      if (!entry || destroyed) return;
      visible = entry.isIntersecting;
      if (visible) tryEnter();
      else {
        cancelEnter();
        neutral();
      }
      syncScroll();
    }, { threshold: 0 });
    observer.observe(visual);
    reduce.addEventListener('change', refresh);
    desktop.addEventListener('change', refresh);
    addEventListener('resize', refresh, { passive: true });
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      destroyed = true;
      observer.disconnect();
      cancelEnter();
      neutral();
      syncScroll();
      reduce.removeEventListener('change', refresh);
      desktop.removeEventListener('change', refresh);
      removeEventListener('resize', refresh);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  };
  const unmount = root => {
    instances.forEach((destroy, section) => {
      if (root === document || root === section || root.contains(section) || !section.isConnected) {
        destroy();
        instances.delete(section);
      }
    });
  };
  const mount = root => {
    instances.forEach((destroy, section) => {
      if (!section.isConnected) {
        destroy();
        instances.delete(section);
      }
    });
    const sections = [...root.querySelectorAll('[data-product-stage]')];
    if (root.matches?.('[data-product-stage]')) sections.unshift(root);
    sections.forEach(section => {
      if (instances.has(section)) return;
      const destroy = create(section);
      if (destroy) instances.set(section, destroy);
    });
  };
  window.TaillaiStageMotion = Object.freeze({ mount, unmount });
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => unmount(event.target));
  addEventListener('pagehide', () => unmount(document));
  addEventListener('pageshow', event => { if (event.persisted) mount(document); });
  mount(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-product-views"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.TaillaiViews) { window.TaillaiViews.mount(document); return; }
  const instances = new Map();
  const unmount = root => {
    for (const [section, destroy] of instances) {
      if (root === section || root.contains(section) || !section.isConnected) { destroy(); instances.delete(section); }
    }
  };
  const mount = root => {
    for (const [section, destroy] of instances) {
      if (!section.isConnected) { destroy(); instances.delete(section); }
    }
    const sections = [...(root.matches?.('[data-product-views]') ? [root] : []), ...root.querySelectorAll('[data-product-views]')];
    sections.forEach(section => {
      if (instances.has(section)) return;
      const track = section.querySelector('[data-views-track]');
      const frames = [...section.querySelectorAll('[data-view-frame]')];
      const controls = section.querySelector('[data-views-controls]');
      if (!track || !controls || !frames.length) return;
      const buttons = [...controls.querySelectorAll('[data-view-target]')];
      const dialog = section.querySelector('[data-views-dialog]');
      const original = section.querySelector('[data-views-original]');
      const caption = section.querySelector('[data-views-caption]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const narrow = window.matchMedia('(max-width: 800px)');
      const aligned = section.dataset.viewComposition === 'aligned';
      const controller = new AbortController();
      const on = (element, type, callback, options = {}) => element?.addEventListener(type, callback, { ...options, signal: controller.signal });
      let frameAnimation;
      let modalAnimation;
      let modalRevision = 0;
      let imageRequest = 0;
      let scrollState;
      let selected = Math.min(Number(track.dataset.viewFocus) || 0, frames.length - 1);
      let origin;
      let scheduled;
      const update = index => {
        selected = index;
        buttons.forEach((button, position) => button.setAttribute('aria-pressed', String(position === index)));
        frames.forEach((frame, position) => frame.classList.toggle('is-active', position === index));
        track.dataset.viewFocus = String(index);
      };
      const select = index => {
        if (aligned || !frames[index]) return;
        update(index);
        if (narrow.matches) {
          track.scrollTo({ left: frames[index].offsetLeft - frames[0].offsetLeft, behavior: reduced.matches ? 'auto' : 'smooth' });
        } else if (!reduced.matches && frames[index].animate) {
          frameAnimation?.cancel();
          frameAnimation = frames[index].animate([{ opacity: .7, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 240, easing: 'ease-out' });
          frameAnimation.onfinish = () => { frameAnimation = undefined; };
        }
      };
      if (!aligned) buttons.forEach((button, index) => {
        on(button, 'click', () => select(index));
        on(button, 'keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault(); buttons[next].focus(); select(next);
        });
      });
      on(track, 'scroll', () => {
        if (aligned || !narrow.matches) return;
        if (scheduled) cancelAnimationFrame(scheduled);
        scheduled = requestAnimationFrame(() => {
          const center = track.getBoundingClientRect().left + track.clientWidth / 2;
          const index = frames.reduce((best, frame, position) => Math.abs(frame.getBoundingClientRect().left + frame.clientWidth / 2 - center) < Math.abs(frames[best].getBoundingClientRect().left + frames[best].clientWidth / 2 - center) ? position : best, 0);
          update(index); scheduled = undefined;
        });
      }, { passive: true });
      if (!aligned) on(narrow, 'change', () => { update(selected); if (narrow.matches) track.scrollTo({ left: frames[selected].offsetLeft - frames[0].offsetLeft, behavior: 'auto' }); });
      const cancelModalAnimation = () => {
        const current = dialog?.open ? { opacity: getComputedStyle(dialog).opacity, transform: getComputedStyle(dialog).transform } : undefined;
        modalRevision += 1;
        modalAnimation?.cancel(); modalAnimation = undefined;
        return current;
      };
      const cleanupModal = restore => {
        imageRequest += 1;
        cancelModalAnimation();
        dialog?.removeAttribute('data-dialog-state');
        original?.removeAttribute('src');
        const savedScroll = scrollState;
        scrollState = undefined;
        savedScroll?.styles.forEach(([element, name, value, priority]) => {
          if (value) element.style.setProperty(name, value, priority);
          else element.style.removeProperty(name);
        });
        if (restore && origin?.isConnected) origin.focus({ preventScroll: true });
        origin = undefined;
        if (savedScroll) window.scrollTo({ left: savedScroll.x, top: savedScroll.y, behavior: 'instant' });
      };
      const finishClose = () => {
        cancelModalAnimation();
        if (dialog?.open) dialog.close();
        cleanupModal(true);
      };
      const closeModal = () => {
        if (!dialog?.open || dialog.dataset.dialogState === 'closing') return;
        imageRequest += 1;
        const current = cancelModalAnimation();
        dialog.dataset.dialogState = 'closing';
        if (reduced.matches || !dialog.animate) { finishClose(); return; }
        const revision = modalRevision;
        modalAnimation = dialog.animate([current, { opacity: 0, transform: 'scale(.99)' }], { duration: 160, easing: 'cubic-bezier(.4,0,1,1)', fill: 'both' });
        modalAnimation.onfinish = () => { if (revision === modalRevision) finishClose(); };
      };
      if (dialog && original && caption && typeof dialog.showModal === 'function') {
        section.querySelectorAll('[data-view-open]').forEach(link => on(link, 'click', async event => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
          const source = link.querySelector('img');
          if (!source) return;
          event.preventDefault();
          const request = ++imageRequest;
          try { await source.decode(); } catch (error) { return; }
          if (request !== imageRequest || controller.signal.aborted || !link.isConnected || !source.naturalWidth) return;
          const fallback = source.currentSrc || source.src;
          original.src = fallback; original.alt = source.alt || ''; original.width = source.naturalWidth; original.height = source.naturalHeight;
          try { await original.decode(); } catch (error) { return; }
          if (request !== imageRequest || controller.signal.aborted || !link.isConnected) return;
          const current = cancelModalAnimation();
          const wasOpen = dialog.open;
          origin = link;
          caption.textContent = link.closest('figure')?.querySelector('figcaption')?.textContent.trim() || '';
          if (!wasOpen) {
            const root = document.documentElement;
            if (!scrollState) {
              const properties = [[root, 'overflow'], [root, 'scrollbar-gutter'], [document.body, 'overflow']];
              scrollState = { x: scrollX, y: scrollY, styles: properties.map(([element, name]) => [element, name, element.style.getPropertyValue(name), element.style.getPropertyPriority(name)]) };
              root.style.setProperty('scrollbar-gutter', 'stable');
              root.style.setProperty('overflow', 'hidden');
              document.body.style.setProperty('overflow', 'hidden');
            }
            dialog.dataset.dialogState = 'opening';
            dialog.showModal();
            dialog.scrollTop = 0;
            getComputedStyle(dialog, '::backdrop').opacity;
            section.querySelector('[data-view-close]')?.focus({ preventScroll: true });
          }
          dialog.dataset.dialogState = 'visible';
          if (!reduced.matches && dialog.animate) {
            const revision = modalRevision;
            modalAnimation = dialog.animate([wasOpen ? current : { opacity: 0, transform: 'scale(.985)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 220, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' });
            modalAnimation.onfinish = () => { if (revision === modalRevision) { modalAnimation.cancel(); modalAnimation = undefined; } };
          }
          if (link.href !== fallback) {
            const large = new Image();
            large.decoding = 'async';
            large.src = link.href;
            large.decode().then(() => {
              if (request !== imageRequest || controller.signal.aborted || !dialog.open || dialog.dataset.dialogState === 'closing' || origin !== link) return;
              original.src = large.src;
            }).catch(() => {});
          }
        }));
        on(section.querySelector('[data-view-close]'), 'click', closeModal);
        on(dialog, 'cancel', event => { event.preventDefault(); closeModal(); });
        on(dialog, 'click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeModal();
        });
        on(dialog, 'close', () => { if (!dialog.open && (scrollState || origin)) cleanupModal(true); });
      }
      on(reduced, 'change', () => {
        if (!reduced.matches) return;
        frameAnimation?.cancel(); frameAnimation = undefined;
        if (dialog?.dataset.dialogState === 'closing') finishClose();
        else { cancelModalAnimation(); if (dialog?.open) dialog.dataset.dialogState = 'visible'; }
      });
      section.dataset.enhanced = 'true';
      controls.hidden = aligned || frames.length < 2;
      update(selected);
      instances.set(section, () => {
        controller.abort();
        if (scheduled) cancelAnimationFrame(scheduled);
        frameAnimation?.cancel();
        if (dialog?.open) dialog.close();
        cleanupModal(false);
        controls.hidden = true;
        delete section.dataset.enhanced;
      });
    });
  };
  window.TaillaiViews = { mount, unmount };
  const initialize = () => {
    mount(document);
    new MutationObserver(() => { for (const [section, destroy] of instances) { if (!section.isConnected) { destroy(); instances.delete(section); } } }).observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => unmount(event.target));
  window.addEventListener('pagehide', () => unmount(document));
  window.addEventListener('pageshow', event => { if (event.persisted) mount(document); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-production-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-production-story')) {
  customElements.define('tl-production-story', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.video = this.querySelector('[data-production-video]');
      if (!this.video) return;
      this.bound = true;
      this.frames = [...this.querySelectorAll('[data-production-scene]')];
      this.status = this.querySelector('[data-production-status]');
      this.onClick = event => {
        const frame = event.target.closest('[data-production-scene]');
        if (!frame || !this.contains(frame) || this.mediaFailed || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const seconds = Number(frame.dataset.productionScene);
        if (!Number.isFinite(seconds)) return;
        event.preventDefault();
        this.pendingScene = { seconds: Math.max(0, seconds), title: frame.dataset.sceneTitle || '' };
        if (this.video.readyState >= 1) this.seekScene();
        else {
          this.video.preload = 'metadata';
          this.video.load();
        }
      };
      this.onMetadata = () => this.seekScene();
      this.onTime = () => this.updateCurrentScene();
      this.onError = () => {
        this.pendingScene = null;
        this.mediaFailed = true;
        if (this.status) this.status.textContent = this.status.dataset.errorLabel || '';
      };
      this.addEventListener('click', this.onClick);
      this.video.addEventListener('loadedmetadata', this.onMetadata);
      this.video.addEventListener('timeupdate', this.onTime);
      this.video.addEventListener('error', this.onError);
    }
    seekScene() {
      if (!this.pendingScene || !this.video) return;
      const scene = this.pendingScene;
      this.pendingScene = null;
      const maximum = Number.isFinite(this.video.duration) ? Math.max(0, this.video.duration - .05) : scene.seconds;
      try { this.video.currentTime = Math.min(scene.seconds, maximum); }
      catch { return; }
      this.updateCurrentScene();
      if (this.status) this.status.textContent = `${this.status.dataset.seekLabel} ${scene.title}`;
      const attempt = this.video.play();
      if (attempt?.catch) attempt.catch(() => {});
    }
    updateCurrentScene() {
      let current = null;
      for (const frame of this.frames) {
        if (Number(frame.dataset.productionScene) <= this.video.currentTime) current = frame;
      }
      this.frames.forEach(frame => {
        if (frame === current) frame.setAttribute('aria-current', 'true');
        else frame.removeAttribute('aria-current');
      });
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.video?.removeEventListener('loadedmetadata', this.onMetadata);
      this.video?.removeEventListener('timeupdate', this.onTime);
      this.video?.removeEventListener('error', this.onError);
      this.video?.pause();
      this.pendingScene = null;
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-project-stages"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('tl-project-flow')) {
    customElements.define('tl-project-flow', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.list = this.querySelector('.tl-project-stages__list');
        this.stages = [...this.querySelectorAll('.tl-project-stages__stage')];
        if (!this.list || !this.stages.length) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.queue = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
        window.addEventListener('scroll', this.queue, {passive: true, signal: this.controller.signal});
        window.addEventListener('resize', this.queue, {passive: true, signal: this.controller.signal});
        this.motion.addEventListener('change', this.queue, {signal: this.controller.signal});
        if (window.ResizeObserver) { this.resize = new ResizeObserver(this.queue); this.resize.observe(this); }
        this.update();
      }
      update() {
        const bounds = this.list.getBoundingClientRect();
        const readingLine = innerHeight * .48;
        const progress = Math.min(1, Math.max(0, (readingLine - bounds.top) / Math.max(1, bounds.height)));
        this.list.style.setProperty('--tl-project-progress', this.motion.matches ? '0' : progress.toFixed(4));
        let active = this.stages.findIndex(stage => stage.getBoundingClientRect().bottom > readingLine);
        if (active < 0) active = this.stages.length - 1;
        const visible = bounds.top < innerHeight && bounds.bottom > 0;
        this.stages.forEach((stage, i) => stage.toggleAttribute('data-current', visible && i === active));
      }
      disconnectedCallback() { this.controller?.abort(); this.resize?.disconnect(); cancelAnimationFrame(this.frame); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-purchase-worksheet"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-purchase-worksheet')) {
    customElements.define('tl-purchase-worksheet', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('[data-worksheet-form]');
        const list = this.querySelector('[data-worksheet-rows]');
        const status = this.querySelector('[data-worksheet-status]');
        const add = this.querySelector('[data-worksheet-add]');
        const rows = () => [...list.querySelectorAll('.tl-worksheet__row')];
        form.addEventListener('submit', event => event.preventDefault());
        form.addEventListener('invalid', event => { const row = event.target.closest('details'); if (row) row.open = true; }, true);
        list.addEventListener('input', event => {
          if (event.target.dataset.field !== 'position') return;
          const row = event.target.closest('details');
          row.querySelector('[data-row-title]').textContent = event.target.value.trim() || `${this.dataset.rowLabel} ${rows().indexOf(row) + 1}`;
        });
        add.addEventListener('click', () => {
          if (rows().length >= 20) { status.textContent = this.dataset.limit; return; }
          const fragment = this.querySelector('[data-worksheet-template]').content.cloneNode(true);
          fragment.querySelector('[data-row-title]').textContent = `${this.dataset.rowLabel} ${rows().length + 1}`;
          list.append(fragment);
          rows().at(-1).querySelector('input').focus();
          status.textContent = this.dataset.added;
          add.disabled = rows().length >= 20;
        });
        this.querySelector('[data-worksheet-export]').addEventListener('click', () => {
          if (!form.reportValidity()) return;
          const meta = [...form.querySelectorAll('[data-meta]')];
          const fields = [...this.querySelector('[data-worksheet-template]').content.querySelectorAll('[data-field]')];
          const heading = element => element.closest('label').firstChild.textContent.trim();
          const note = this.querySelector('[data-worksheet-note]').textContent.trim();
          const data = [[...meta.map(heading), ...fields.map(heading), this.dataset.noteLabel]];
          rows().forEach(row => {
            const values = [...row.querySelectorAll('[data-field]')].map(input => input.tagName === 'SELECT' ? (input.value ? input.selectedOptions[0].textContent : '') : input.value);
            data.push([...meta.map(input => input.value), ...values, note]);
          });
          const quote = value => {
            let clean = String(value).trim();
            if (/^[=+\-@]/.test(clean)) clean = "'" + clean;
            return '"' + clean.replace(/"/g, '""') + '"';
          };
          const csv = '\uFEFF' + data.map(row => row.map(quote).join(',')).join('\r\n');
          const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
          const link = document.createElement('a');
          link.href = url;
          link.download = 'Taillai-purchase-worksheet.csv';
          link.click();
          setTimeout(() => URL.revokeObjectURL(url), 1000);
          status.textContent = this.dataset.downloaded;
        });
        const inquire = this.querySelector('[data-worksheet-inquire]');
        if (inquire) {
          const prepareDraft = event => {
            if (event.type === 'auxclick' && event.button !== 1) return;
            if (!form.reportValidity()) { event.preventDefault(); return; }
            const fieldLabel = input => input.closest('label').firstChild.textContent.trim();
            const value = input => input.tagName === 'SELECT' ? (input.value ? input.selectedOptions[0].textContent.trim() : '') : input.value.trim();
            const meta = [...form.querySelectorAll('[data-meta]')].filter(input => value(input)).map(input => `${fieldLabel(input)}: ${value(input)}`);
            const lines = rows().map((row, index) => {
              const filled = [...row.querySelectorAll('[data-field]')].filter(input => value(input));
              return filled.length ? `${index + 1}. ` + filled.map(input => `${fieldLabel(input)}: ${value(input)}`).join(' | ') : '';
            }).filter(Boolean);
            const message = [this.querySelector('h2').textContent.trim(), ...meta, '', ...lines, '', this.querySelector('[data-worksheet-note]').textContent.trim()].join('\n');
            const target = new URL(inquire.href, window.location.origin);
            if (target.origin !== window.location.origin) return;
            try {
              for (const key of Object.keys(sessionStorage)) {
                if (!key.startsWith('tl-worksheet-draft:')) continue;
                try { if (Date.now() - JSON.parse(sessionStorage.getItem(key)).createdAt > 900000) sessionStorage.removeItem(key); } catch { sessionStorage.removeItem(key); }
              }
              const token = crypto.randomUUID();
              sessionStorage.setItem(`tl-worksheet-draft:${token}`, JSON.stringify({message, createdAt: Date.now()}));
              target.searchParams.set('worksheet', token);
              target.searchParams.set('source_page', window.location.pathname);
              inquire.href = target.pathname + target.search + target.hash;
            } catch {
              event.preventDefault();
              status.textContent = this.dataset.transferError;
            }
          };
          inquire.addEventListener('click', prepareDraft);
          inquire.addEventListener('auxclick', prepareDraft);
        }
        this.querySelector('[data-worksheet-actions]').hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-quote"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-quote-form')) {
    customElements.define('tl-quote-form', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('form');
        const button = this.querySelector('[data-quote-submit]');
        const result = this.querySelector('[data-quote-result]');
        if (result) result.focus({ preventScroll: true });
        if (!form || !button) return;
        const modelInput = form.querySelector('[name="contact[model]"]');
        const parameters = new URLSearchParams(window.location.search);
        const requestedModel = parameters.get('model');
        if (modelInput && !modelInput.value.trim() && requestedModel) {
          modelInput.value = requestedModel.replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 80);
        }
        const messageInput = form.querySelector('[name="contact[body]"]');
        const worksheetToken = parameters.get('worksheet');
        if (messageInput && !messageInput.value.trim() && /^[0-9a-f-]{36}$/i.test(worksheetToken || '')) {
          const key = `tl-worksheet-draft:${worksheetToken}`;
          try {
            const draft = JSON.parse(sessionStorage.getItem(key));
            if (draft && typeof draft.message === 'string' && draft.message.length <= 80000 && Date.now() - draft.createdAt >= 0 && Date.now() - draft.createdAt < 900000) {
              messageInput.value = draft.message.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').trim();
              sessionStorage.removeItem(key);
            }
          } catch {}
        }
        const brief = parameters.get('brief');
        if (messageInput && !messageInput.value.trim() && brief) {
          messageInput.value = brief.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').trim().slice(0, 4000);
        }
        const requestType = form.querySelector('[name="contact[request_type]"]');
        const typeMap = {home: 'Private home', wholesale: 'Wholesale', project: 'Project', documents: 'Documents', service: 'Service', dealer: 'Dealer'};
        if (requestType && !requestType.value && typeMap[parameters.get('type')]) requestType.value = typeMap[parameters.get('type')];
        const reset = () => {
          button.disabled = false;
          button.textContent = button.dataset.idleLabel;
          form.removeAttribute('aria-busy');
        };
        this.handlePageShow = reset;
        window.addEventListener('pageshow', this.handlePageShow);
        form.addEventListener('submit', (event) => {
          queueMicrotask(() => {
            if (event.defaultPrevented) return;
            button.disabled = true;
            button.textContent = button.dataset.pendingLabel;
            form.setAttribute('aria-busy', 'true');
            this.resetTimer = window.setTimeout(reset, 15000);
          });
        });
      }
      disconnectedCallback() {
        window.removeEventListener('pageshow', this.handlePageShow);
        window.clearTimeout(this.resetTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-resource-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-resource-library')) {
    customElements.define('tl-resource-library', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const input = this.querySelector('[data-resource-search]');
        const tools = this.querySelector('[data-resource-tools]');
        const counter = this.querySelector('[data-resource-count]');
        const empty = this.querySelector('[data-resource-empty]');
        const rows = [...this.querySelectorAll('[data-resource-row]')];
        if (!input || !tools || !counter || !empty) return;
        const search = () => {
          const words = input.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
          let count = 0;
          rows.forEach(row => {
            const text = row.textContent.toLocaleLowerCase();
            const match = words.every(word => text.includes(word));
            row.hidden = !match;
            if (match) count += 1;
          });
          counter.textContent = counter.dataset.template.replace('%count%', String(count));
          empty.hidden = count !== 0;
        };
        input.addEventListener('input', search);
        tools.hidden = false;
        search();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-scene-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-scene-carousel')) customElements.define('tl-scene-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const { signal } = this._abort;
      const slides = [...this.querySelectorAll('[data-scene]')];
      const tabs = [...this.querySelectorAll('[data-scene-tab]')];
      if (slides.length < 2) return;
      const viewport = this.querySelector('.tl-scene__viewport');
      const controls = this.querySelector('.tl-scene__controls');
      const status = this.querySelector('[data-scene-status]');
      const rotation = this.querySelector('[data-scene-rotation]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const delay = Number(this.dataset.autoplay) || 0;
      let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      let requested = index;
      let animations = [];
      let revision = 0;
      let pending;
      let timer;
      let progress;
      let gesture;
      let suppressClick = false;
      let hovered = false;
      let playOverride = false;
      let windowBlurred = false;
      let imageReady = false;
      let inView = typeof IntersectionObserver !== 'function';
      let paused = false;
      let pausedBy = null;
      let timerStarted = 0;
      const stopTimer = () => {
        clearTimeout(timer);
        timerStarted = 0;
        progress?.cancel();
        progress = null;
        this.removeAttribute('data-rotating');
      };
      const canRotate = () => delay && !paused && !motion.matches && !document.hidden && !windowBlurred && inView && (!hovered || playOverride) && !gesture && imageReady && !window.Shopify?.designMode && !signal.aborted;
      const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
        inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .15);
        updateTimer();
      }, { threshold: .15 }) : null;
      const settle = () => {
        animations.forEach(animation => animation.cancel());
        animations = [];
        slides.forEach(slide => slide.classList.remove('is-transitioning'));
      };
      const cancelPending = () => {
        revision += 1;
        pending = null;
        requested = index;
        settle();
      };
      const updateRotation = () => {
        if (!rotation) return;
        rotation.disabled = motion.matches || Boolean(window.Shopify?.designMode);
        const suspended = paused || rotation.disabled;
        rotation.setAttribute('aria-label', suspended ? this.dataset.playLabel : this.dataset.pauseLabel);
        rotation.setAttribute('aria-pressed', String(suspended));
        rotation.querySelector('[data-rotation-icon]').textContent = suspended ? '▷' : 'Ⅱ';
      };
      const updateTimer = () => {
        stopTimer();
        if (!canRotate() || requested !== index || animations.length) return;
        this.setAttribute('data-rotating', '');
        timerStarted = performance.now();
        const bar = tabs[index]?.querySelector('[data-scene-progress]');
        if (bar?.animate) progress = bar.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: delay, easing: 'linear', fill: 'forwards' });
        timer = setTimeout(() => go(index + 1, { announce: false, automatic: true }), delay);
      };
      const warmImage = async i => {
        const image = slides[i]?.querySelector('img');
        if (!image) return false;
        image.loading = 'eager';
        if (image.complete) return image.naturalWidth > 0;
        let timeout;
        try {
          await Promise.race([image.decode(), new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('image timeout')), 8000); })]);
          return image.naturalWidth > 0;
        } catch { return false; }
        finally { clearTimeout(timeout); }
      };
      const go = async (next, options = {}) => {
        next = (next + slides.length) % slides.length;
        requested = next;
        stopTimer();
        if (options.instant) cancelPending();
        if (animations.length) {
          // Preserve the current image stack; finish it quickly before the latest request.
          pending = { next, options };
          animations.forEach(animation => {
            const remaining = animation.effect.getComputedTiming().endTime - (animation.currentTime || 0);
            animation.updatePlaybackRate(Math.max(1, remaining / 160));
          });
          return;
        }
        requested = next;
        const token = ++revision;
        if (next === index) {
          if (options.focus) tabs[index]?.focus({ preventScroll: true });
          updateTimer();
          return;
        }
        const loaded = await warmImage(next);
        if (signal.aborted || token !== revision) return;
        if (!loaded || (options.automatic && !canRotate())) {
          requested = index;
          if (!loaded && options.automatic && (options.skipped || 0) < slides.length - 2 && canRotate()) {
            go(next + 1, { ...options, skipped: (options.skipped || 0) + 1 });
          } else updateTimer();
          return;
        }
        const previous = index;
        index = next;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        if (!motion.matches && !options.instant && typeof slides[index].animate === 'function') {
          const incoming = slides[index], outgoing = slides[previous];
          [incoming, outgoing].forEach(slide => slide.classList.add('is-transitioning'));
          const animate = (element, frames, timing) => animations.push(element.animate(frames, { fill: 'both', ...timing }));
          // Keep the old photograph opaque underneath so the crossfade never exposes the canvas.
          animate(outgoing, [{ opacity: 1 }, { opacity: 1 }], { duration: 1200 });
          animate(incoming, [{ opacity: 0 }, { opacity: 1 }], { duration: 1050, easing: 'cubic-bezier(.4,0,.2,1)' });
          animate(incoming.querySelector('.tl-scene__media'), [{ transform: 'scale(1.018)' }, { transform: 'scale(1)' }], { duration: 1200, easing: 'cubic-bezier(.22,1,.36,1)' });
          animate(outgoing.querySelector('.tl-scene__copy'), [{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-out' });
          animate(incoming.querySelector('.tl-scene__copy'), [{ opacity: 0 }, { opacity: 1 }], { delay: 200, duration: 600, easing: 'ease-out' });
          Promise.allSettled(animations.map(animation => animation.finished)).then(() => {
            if (signal.aborted || token !== revision) return;
            settle();
            const queued = pending;
            pending = null;
            if (queued) go(queued.next, queued.options);
            else updateTimer();
          });
        }
        if (options.announce !== false && status) status.textContent = tabs[index]?.getAttribute('aria-label') || '';
        if (options.focus || slides[previous].contains(document.activeElement)) tabs[index]?.focus({ preventScroll: true });
        warmImage((index + 1) % slides.length);
        updateTimer();
      };
      this.querySelector('[data-scene-prev]')?.addEventListener('click', () => go(requested - 1), { signal });
      this.querySelector('[data-scene-next]')?.addEventListener('click', () => go(requested + 1), { signal });
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => go(i), { signal });
        tab.addEventListener('keydown', event => {
          const next = event.key === 'ArrowRight' ? i + 1 : event.key === 'ArrowLeft' ? i - 1 : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : null;
          if (next === null) return;
          event.preventDefault();
          go(next, { focus: true });
        }, { signal });
      });
      rotation?.addEventListener('click', () => { paused = !paused; pausedBy = paused ? 'user' : null; playOverride = !paused; updateRotation(); updateTimer(); }, { signal });
      const cancelGesture = () => {
        if (gesture && viewport.hasPointerCapture(gesture.id)) viewport.releasePointerCapture(gesture.id);
        gesture = null;
        updateTimer();
      };
      viewport.addEventListener('pointerdown', event => {
        suppressClick = false;
        if (!event.isPrimary || event.button !== 0 || event.target.closest('a, button, input, select, textarea, [contenteditable]')) return;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, time: performance.now(), locked: false };
        stopTimer();
      }, { signal });
      viewport.addEventListener('pointermove', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const x = event.clientX - gesture.x;
        const y = event.clientY - gesture.y;
        if (!gesture.locked && Math.abs(y) > 8 && Math.abs(y) > Math.abs(x) * 1.15) { cancelGesture(); return; }
        if (!gesture.locked && Math.abs(x) > 12 && Math.abs(x) > Math.abs(y) * 1.35) { gesture.locked = true; viewport.setPointerCapture(event.pointerId); }
        if (gesture.locked) event.preventDefault();
      }, { signal, passive: false });
      window.addEventListener('pointerup', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        if (gesture.locked) {
          const distance = event.clientX - gesture.x;
          const velocity = Math.abs(distance) / Math.max(1, performance.now() - gesture.time);
          suppressClick = true;
          const threshold = Math.max(36, Math.min(72, viewport.clientWidth * .09));
          if (Math.abs(distance) >= threshold || (Math.abs(distance) > 20 && velocity > .45)) go(requested + (distance < 0 ? 1 : -1));
        }
        cancelGesture();
      }, { signal });
      window.addEventListener('pointercancel', cancelGesture, { signal });
      window.addEventListener('blur', () => { windowBlurred = true; cancelGesture(); }, { signal });
      window.addEventListener('focus', () => { windowBlurred = false; updateTimer(); }, { signal });
      viewport.addEventListener('click', event => {
        if (!suppressClick || event.detail === 0) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      }, { signal, capture: true });
      viewport.addEventListener('dragstart', event => { if (gesture) event.preventDefault(); }, { signal });
      const updateHover = target => {
        const control = target instanceof Element ? target.closest('a, button, input, select, textarea, [contenteditable]') : null;
        const nextHovered = Boolean(control && this.contains(control));
        const nextOverride = playOverride && control === rotation;
        if (hovered === nextHovered && playOverride === nextOverride) return;
        hovered = nextHovered;
        playOverride = nextOverride;
        updateTimer();
      };
      this.addEventListener('pointerover', event => { if (event.pointerType === 'mouse') updateHover(event.target); }, { signal });
      this.addEventListener('pointerout', event => { if (event.pointerType === 'mouse') updateHover(event.relatedTarget); }, { signal });
      this.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && gesture && !gesture.locked) cancelGesture(); }, { signal });
      const pauseForKeyboard = () => { paused = true; pausedBy = 'keyboard'; playOverride = false; updateRotation(); updateTimer(); };
      this.addEventListener('focusin', event => {
        if (event.target !== rotation && event.target.matches(':focus-visible')) pauseForKeyboard();
        else updateTimer();
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.target !== rotation && !['Shift', 'Control', 'Alt', 'Meta'].includes(event.key)) pauseForKeyboard();
      }, { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => { if (!signal.aborted) updateTimer(); }), { signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) cancelPending(); updateTimer(); }, { signal });
      motion.addEventListener('change', () => { cancelPending(); updateRotation(); updateTimer(); }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-scene]') || slides.find(item => item.dataset.blockId === event.detail?.blockId);
        const selected = slides.indexOf(slide);
        if (selected !== -1) go(selected, { instant: true, announce: false });
      }, { signal });
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(this)) this.disconnectedCallback(); }, { signal });
      signal.addEventListener('abort', () => {
        stopTimer();
        cancelPending();
        observer?.disconnect();
        if (gesture && viewport.hasPointerCapture(gesture.id)) viewport.releasePointerCapture(gesture.id);
        gesture = null;
        this.classList.remove('is-ready');
        if (controls) controls.hidden = true;
      }, { once: true });
      this.classList.add('is-ready');
      if (controls) controls.hidden = false;
      updateRotation();
      observer?.observe(this);
      warmImage(index).then(() => {
        if (signal.aborted) return;
        imageReady = true;
        warmImage((index + 1) % slides.length);
        updateTimer();
      });
      if (new URLSearchParams(location.search).get('carousel-check') === '1') {
        const output = document.createElement('pre');
        output.dataset.carouselDiagnostics = '';
        output.style.cssText = 'position:fixed;z-index:2147483647;top:80px;right:12px;max-width:calc(100vw - 24px);width:360px;max-height:55vh;overflow:auto;box-sizing:border-box;margin:0;padding:16px;background:#fff;color:#333;border:1px solid #ddd;border-radius:8px;font:12px/1.5 monospace;white-space:pre-wrap;user-select:text';
        const history = [];
        let previousState = '';
        const renderDiagnostics = () => {
          const state = {
            release: '20261023', theme: window.Shopify?.theme?.id, slide: index + 1,
            autoplayMs: delay, rotating: this.hasAttribute('data-rotating'), pausedBy,
            reducedMotion: motion.matches, tabHidden: document.hidden,
            windowBlurred, documentFocused: document.hasFocus(), inView,
            controlHovered: hovered, playOverride, gestureActive: Boolean(gesture),
            imageReady, requestedSlide: requested + 1, animations: animations.length,
            designMode: Boolean(window.Shopify?.designMode),
            imagesLoaded: slides.map(slide => { const image = slide.querySelector('img'); return Boolean(image?.complete && image.naturalWidth); })
          };
          const key = JSON.stringify(state);
          if (key !== previousState) {
            history.push({ at: new Date().toLocaleTimeString(), slide: state.slide, rotating: state.rotating, pausedBy, reducedMotion: motion.matches, windowBlurred, controlHovered: hovered });
            if (history.length > 6) history.shift();
            previousState = key;
          }
          output.textContent = JSON.stringify({ ...state, timerAgeMs: timerStarted ? Math.round(performance.now() - timerStarted) : 0, history }, null, 2);
        };
        document.body.append(output);
        renderDiagnostics();
        const diagnosticTimer = setInterval(renderDiagnostics, 1000);
        signal.addEventListener('abort', () => { clearInterval(diagnosticTimer); output.remove(); }, { once: true });
      }
    }
    disconnectedCallback() { this._abort?.abort(); this._abort = null; }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-solution-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-solution-builder')) {
    customElements.define('tl-solution-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('[data-builder-form]');
        const button = this.querySelector('[data-builder-generate]');
        const result = this.querySelector('[data-builder-result]');
        const preview = this.querySelector('[data-builder-preview]');
        const brief = this.querySelector('[data-builder-brief]');
        const link = this.querySelector('[data-builder-continue]');
        const status = this.querySelector('[data-builder-status]');
        if (!form || !button || !result || !preview || !brief || !link) return;
        const destination = new URL(link.href, window.location.href);
        const progressPanel = this.querySelector('[data-builder-progress-panel]');
        const progress = this.querySelector('[data-builder-progress]');
        const completed = this.querySelector('[data-builder-completed]');
        const questions = [...this.querySelectorAll('[data-builder-question]')];
        const steps = [...this.querySelectorAll('[data-builder-step]')];
        const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const animations = new WeakMap();
        const updateProgress = event => {
          let count = 0;
          questions.forEach((question, index) => {
            const answered = Boolean(question.querySelector('input:checked'));
            if (answered) count += 1;
            if (steps[index]) steps[index].dataset.answered = String(answered);
          });
          if (progress) progress.value = count;
          if (completed) completed.textContent = String(count);
          if (event?.type !== 'change' || event.target.type !== 'radio' || preference.matches) return;
          const question = event.target.closest('[data-builder-question]');
          if (question && typeof question.animate === 'function') {
            animations.get(question)?.cancel();
            animations.set(question, question.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(5px)' }, { transform: 'translateX(0)' }], { duration: 360, easing: 'cubic-bezier(.22,.68,0,1)' }));
          }
        };
        let generatedSignature = null;
        let stale = false;
        const sourceLines = () => {
          const lines = [this.dataset.summaryTitle || ''];
          this.querySelectorAll('[data-builder-question]').forEach(question => {
            const choice = question.querySelector('input:checked');
            if (choice) lines.push(`${question.dataset.label}: ${choice.value}`);
          });
          this.querySelectorAll('[data-builder-area], [data-builder-city], [data-builder-extra]').forEach(field => {
            if (field.value.trim()) lines.push(`${field.dataset.label}: ${field.value.trim()}`);
          });
          return lines.filter(Boolean);
        };
        const setStatus = message => {
          if (!status) return;
          status.textContent = this.querySelector(`[data-builder-${message}]`)?.textContent || '';
          status.dataset.stale = String(stale);
        };
        const updateLink = () => {
          if (generatedSignature === null || stale) {
            link.href = `#${button.id}`;
            if (stale) {
              link.setAttribute('aria-disabled', 'true');
              if (status) link.setAttribute('aria-describedby', status.id);
            }
            return;
          }
          link.removeAttribute('aria-disabled');
          link.removeAttribute('aria-describedby');
          if (destination.origin !== window.location.origin) return;
          const url = new URL(destination);
          if (!url.searchParams.has('type')) url.searchParams.set('type', 'home');
          url.searchParams.delete('brief');
          if (brief.value.trim()) url.searchParams.set('brief', brief.value.trim().slice(0, 4000));
          link.href = `${url.pathname}${url.search}${url.hash}`;
        };
        const refreshSourceState = () => {
          if (generatedSignature === null) return;
          stale = JSON.stringify(sourceLines()) !== generatedSignature;
          setStatus(stale ? 'changed' : 'ready');
          updateLink();
        };
        const generate = message => {
          if (!form.reportValidity()) return;
          const lines = sourceLines();
          generatedSignature = JSON.stringify(lines);
          stale = false;
          brief.value = lines.join('\n').slice(0, 4000);
          result.hidden = false;
          preview.hidden = true;
          setStatus(message);
          updateLink();
          brief.focus();
        };
        form.addEventListener('submit', event => {
          event.preventDefault();
          generate('ready');
        });
        form.addEventListener('input', refreshSourceState);
        form.addEventListener('change', updateProgress);
        form.addEventListener('change', refreshSourceState);
        brief.addEventListener('input', updateLink);
        link.addEventListener('click', event => {
          if (generatedSignature === null) {
            event.preventDefault();
            generate('review-first');
            return;
          }
          refreshSourceState();
          if (stale) {
            event.preventDefault();
            button.focus();
            return;
          }
          updateLink();
        });
        button.hidden = false;
        if (progressPanel) progressPanel.hidden = false;
        updateProgress();
        updateLink();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-support-workbench"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-support-workbench')) {
  customElements.define('tl-support-workbench', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.tabs = [...this.querySelectorAll('[data-support-tab]')];
      this.panels = [...this.querySelectorAll('[data-support-panel]')];
      this.searchInput = this.querySelector('[data-support-search]');
      this.rows = [...this.querySelectorAll('[data-support-document]')];
      this.brief = this.querySelector('[data-support-brief]');
      this.link = this.querySelector('[data-support-continue]');
      this.baseUrl = this.link.href;
      this.model = this.querySelector('[data-support-model]');
      const tabs = this.querySelector('[data-support-tabs]');
      this.hasTasks = this.tabs.length > 0 && this.tabs.length === this.panels.length;
      if (this.hasTasks) {
        tabs.hidden = false;
        tabs.setAttribute('role', 'tablist');
        this.tabs.forEach((button, index) => {
          button.setAttribute('role', 'tab');
          button.addEventListener('click', () => this.select(index), options);
          button.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault(); this.select(next); this.tabs[next].focus();
          }, options);
        });
      }
      this.querySelector('[data-support-search-tools]').hidden = false;
      this.querySelector('[data-support-preparation]').hidden = !this.hasTasks;
      this.querySelector('[data-support-preview]').hidden = !this.hasTasks;
      this.searchInput.addEventListener('input', () => this.search(), options);
      this.querySelector('[data-support-clear]').addEventListener('click', () => { this.searchInput.value = ''; this.search(); this.searchInput.focus(); }, options);
      this.querySelector('[data-support-use-search]').addEventListener('click', () => { this.model.value = this.searchInput.value.trim().slice(0, 80); this.update(); this.model.focus(); }, options);
      this.querySelector('[data-support-find-model]').addEventListener('click', () => { this.searchInput.value = this.model.value.trim(); this.search(); this.searchInput.focus(); }, options);
      this.querySelectorAll('[data-support-preparation] input, [data-support-preparation] textarea').forEach(field => field.addEventListener('input', () => this.update(), options));
      this.querySelector('[data-support-copy]').addEventListener('click', async () => {
        const status = this.querySelector('[data-support-copy-status]');
        try { await navigator.clipboard.writeText(this.brief.value); status.textContent = status.dataset.success; }
        catch { this.brief.focus(); this.brief.select(); status.textContent = status.dataset.fallback; }
      }, options);
      this.addEventListener('shopify:block:select', event => { const index = this.panels.indexOf(event.target.closest('[data-support-panel]')); if (index >= 0) this.select(index, false); }, options);
      if (this.hasTasks) {
        const initial = this.tabs.findIndex(button => button.getAttribute('aria-selected') === 'true');
        this.active = null;
        this.select(initial < 0 ? 0 : initial);
      }
      this.search();
    }
    select(index) {
      if (!Number.isInteger(index) || !this.panels[index] || this.active === index) return;
      this.active = index;
      this.tabs.forEach((button, i) => { button.setAttribute('aria-selected', String(i === index)); button.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', this.tabs[i].id); });
      this.update();
    }
    search() {
      const words = this.searchInput.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      let count = 0;
      this.rows.forEach(row => {
        const text = [row.dataset.searchTitle, row.dataset.searchModel, row.dataset.searchCategory].join(' ').toLocaleLowerCase();
        const match = words.every(word => text.includes(word));
        row.hidden = !match; if (match) count += 1;
      });
      const status = this.querySelector('[data-support-count]');
      status.textContent = status.dataset.template.replace('__COUNT__', String(count));
      this.querySelector('[data-support-empty]').hidden = count !== 0;
    }
    update() {
      const panel = this.panels[this.active];
      if (!panel) return;
      const lines = [this.dataset.briefTitle, panel.querySelector('[data-support-task-title]').textContent.trim()];
      [['model', this.dataset.modelLabel], ['language', this.dataset.languageLabel], ['edition', this.dataset.editionLabel], ['location', this.dataset.locationLabel], ['question', this.dataset.questionLabel]].forEach(([name, label]) => {
        const value = this.querySelector('[data-support-' + name + ']').value.trim();
        lines.push(label + ': ' + (value || this.dataset.emptyValue));
      });
      this.brief.value = lines.join('\n');
      const target = new URL(this.baseUrl, location.href);
      if (target.origin !== location.origin) return;
      target.searchParams.set('type', panel.dataset.requestType);
      target.searchParams.set('brief', this.brief.value.slice(0, 4000));
      target.searchParams.set('source_page', location.pathname);
      if (this.model.value.trim()) target.searchParams.set('model', this.model.value.trim().slice(0, 80));
      else target.searchParams.delete('model');
      this.link.href = target.pathname + target.search + target.hash;
      this.querySelector('[data-support-copy-status]').textContent = '';
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-technical-catalog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-technical-catalog')) {
    customElements.define('tl-technical-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const rows = [...this.querySelectorAll('[data-tech-record]')];
        const filter = this.querySelector('[data-tech-filter]');
        const count = this.querySelector('[data-tech-count]');
        filter.addEventListener('change', () => {
          rows.forEach(row => { row.hidden = filter.value !== 'all' && row.dataset.family !== filter.value; });
          count.textContent = rows.filter(row => !row.hidden).length;
        });
        this.querySelector('[data-tech-export]').addEventListener('click', () => {
          const clean = value => String(value).replace(/\s+/g, ' ').trim();
          const quote = value => '"' + clean(value).replace(/"/g, '""') + '"';
          const header = [...this.querySelectorAll('thead th')].map(cell => cell.textContent);
          const note = this.querySelector('.tl-tech__note').textContent;
          const data = [[...header, this.dataset.noteLabel]];
          rows.filter(row => !row.hidden).forEach(row => {
            const source = [...row.querySelectorAll('dt')].map(term => `${term.textContent}: ${term.nextElementSibling.textContent}`).join(' | ');
            data.push([
              `${row.querySelector('th strong').textContent} | ${row.querySelector('th span').textContent}`,
              ...[...row.children].slice(1, 4).map(cell => cell.innerText), source, note
            ]);
          });
          const csv = '\uFEFF' + data.map(row => row.map(quote).join(',')).join('\r\n');
          const objectUrl = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
          const link = document.createElement('a');
          link.href = objectUrl;
          link.download = 'Taillai-' + filter.value + '-technical-data.csv';
          link.click();
          setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
        });
        this.querySelector('[data-tech-controls]').hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-technical-desk"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-technical-preparation')) {
  customElements.define('tl-technical-preparation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.steps = Array.from(this.querySelectorAll('[data-prep-step]'));
      if (!this.steps.length) return;
      this.querySelectorAll('[data-prep-enhancement]').forEach(element => element.hidden = false);
      this.addEventListener('change', () => this.update(), {signal:this.controller.signal});
      this.querySelector('[data-prep-project]').addEventListener('input', () => this.update(), {signal:this.controller.signal});
      this.querySelector('[data-prep-build]').addEventListener('click', () => {
        this.generated = true;
        const result = this.querySelector('[data-prep-result]');
        result.hidden = false;
        this.querySelector('[data-prep-build]').setAttribute('aria-expanded', 'true');
        this.update();
        this.animation?.cancel();
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.animation = result.animate([{opacity:0,transform:'translateY(4px)'},{opacity:1,transform:'none'}], {duration:220,easing:'cubic-bezier(0.22,1,0.36,1)'});
        }
        const text = this.querySelector('[data-prep-text]');
        text.focus();
        text.setSelectionRange(0, 0);
        text.scrollTop = 0;
      }, {signal:this.controller.signal});
      this.update();
    }
    update() {
      let done = 0;
      const lines = this.steps.map(step => {
        const prepared = step.querySelector('[data-prepared-input]').checked;
        step.toggleAttribute('data-prepared', prepared);
        if (prepared) done++;
        return step.dataset.prepTitle + ': ' + (prepared ? this.dataset.preparedLabel : this.dataset.pendingLabel);
      });
      this.querySelector('[data-prep-status]').textContent = this.dataset.statusTemplate.replace('__DONE__', done).replace('__TOTAL__', this.steps.length);
      this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', done);
      this.querySelector('[data-prep-meter]').style.transform = 'scaleX(' + done / this.steps.length + ')';
      if (!this.generated) return;
      const project = this.querySelector('[data-prep-project]').value.trim();
      const source = location.origin + location.pathname + '#' + this.closest('section').id;
      const text = [this.dataset.heading, ...(project ? [this.dataset.projectLabel + ': ' + project] : []), ...lines, this.dataset.note, this.dataset.sourceLabel + ': ' + source].join('\n');
      this.querySelector('[data-prep-text]').value = text;
      const url = new URL(this.dataset.quoteUrl, location.origin);
      url.searchParams.set('type', 'project');
      url.searchParams.set('brief', text);
      url.searchParams.set('source_page', location.pathname);
      this.querySelector('[data-prep-continue]').href = url.href;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.animation?.cancel();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-biz-documents"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-v9-biz-documents')){customElements.define('tl-v9-biz-documents',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.buttons=[...this.querySelectorAll('[data-v9-tab]')];this.panels=[...this.querySelectorAll('[data-v9-panel]')];const tabs=this.querySelector('[data-v9-tabs]');if(tabs&&this.buttons.length){tabs.hidden=false;tabs.setAttribute('role','tablist');this.buttons.forEach((button,i)=>{button.setAttribute('role','tab');button.addEventListener('click',()=>this.select(i),{signal:this.abort.signal});button.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(i+1)%this.buttons.length;else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(i-1+this.buttons.length)%this.buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.buttons.length-1;else return;event.preventDefault();this.select(next);this.buttons[next].focus();},{signal:this.abort.signal});});this.select(0,false);}if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){this.observer.unobserve(entry.target);if(!this.motion.matches)this.animations.push(entry.target.animate([{opacity:.4,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'}));}}),{threshold:.15});this.querySelectorAll('[data-v9-reveal]').forEach(e=>this.observer.observe(e));}this.motion.addEventListener('change',()=>{if(this.motion.matches)this.animations.forEach(a=>a.cancel());},{signal:this.abort.signal});}select(index,animate=true){this.dataset.active=String(index+1);this.buttons.forEach((b,i)=>{b.setAttribute('aria-selected',String(i===index));b.tabIndex=i===index?0:-1;});this.panels.forEach((p,i)=>{p.hidden=i!==index;p.setAttribute('role','tabpanel');if(i===index&&animate&&!this.motion.matches)this.animations.push(p.animate([{opacity:.2,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:360,easing:'ease-out'}));});}disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-biz-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-v9-biz-gallery')){customElements.define('tl-v9-biz-gallery',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.buttons=[...this.querySelectorAll('[data-v9-tab]')];this.panels=[...this.querySelectorAll('[data-v9-panel]')];const tabs=this.querySelector('[data-v9-tabs]');if(tabs&&this.buttons.length){tabs.hidden=false;tabs.setAttribute('role','tablist');this.buttons.forEach((button,i)=>{button.setAttribute('role','tab');button.addEventListener('click',()=>this.select(i),{signal:this.abort.signal});button.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(i+1)%this.buttons.length;else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(i-1+this.buttons.length)%this.buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.buttons.length-1;else return;event.preventDefault();this.select(next);this.buttons[next].focus();},{signal:this.abort.signal});});this.select(0,false);}if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){this.observer.unobserve(entry.target);if(!this.motion.matches)this.animations.push(entry.target.animate([{opacity:.4,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'}));}}),{threshold:.15});this.querySelectorAll('[data-v9-reveal]').forEach(e=>this.observer.observe(e));}this.motion.addEventListener('change',()=>{if(this.motion.matches)this.animations.forEach(a=>a.cancel());},{signal:this.abort.signal});}select(index,animate=true){this.dataset.active=String(index+1);this.buttons.forEach((b,i)=>{b.setAttribute('aria-selected',String(i===index));b.tabIndex=i===index?0:-1;});this.panels.forEach((p,i)=>{p.hidden=i!==index;p.setAttribute('role','tabpanel');if(i===index&&animate&&!this.motion.matches)this.animations.push(p.animate([{opacity:.2,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:360,easing:'ease-out'}));});}disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-biz-journey"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-v9-biz-journey')){customElements.define('tl-v9-biz-journey',class extends HTMLElement{connectedCallback(){if(this.abort&&!this.abort.signal.aborted)return;this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.buttons=[...this.querySelectorAll('[data-v9-tab]')];this.panels=[...this.querySelectorAll('[data-v9-panel]')];const tabs=this.querySelector('[data-v9-tabs]');if(tabs&&this.buttons.length){tabs.hidden=false;tabs.setAttribute('role','tablist');const hint=this.querySelector('[data-v9-nav-hint]');if(hint)hint.hidden=false;this.buttons.forEach((button,i)=>{button.setAttribute('role','tab');button.addEventListener('click',()=>this.select(i),{signal:this.abort.signal});button.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(i+1)%this.buttons.length;else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(i-1+this.buttons.length)%this.buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.buttons.length-1;else return;event.preventDefault();this.select(next);this.buttons[next].focus();},{signal:this.abort.signal});});this.select(0,false);}if('IntersectionObserver'in window&&!this.classList.contains('v9b-journey--mobile-tabs')){this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){this.observer.unobserve(entry.target);if(!this.motion.matches)this.addAnimation(entry.target.animate([{opacity:.4,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'}));}}),{threshold:.15});this.querySelectorAll('[data-v9-reveal]').forEach(e=>this.observer.observe(e));}this.motion.addEventListener('change',()=>{if(this.motion.matches){this.animations.forEach(a=>a.cancel());this.animations=[];}},{signal:this.abort.signal});}addAnimation(animation){this.animations.push(animation);animation.addEventListener('finish',()=>{this.animations=this.animations.filter(current=>current!==animation);},{once:true});}select(index,animate=true){this.animations.forEach(animation=>animation.cancel());this.animations=[];this.dataset.active=String(index+1);this.buttons.forEach((b,i)=>{b.setAttribute('aria-selected',String(i===index));b.tabIndex=i===index?0:-1;});this.panels.forEach((p,i)=>{p.hidden=i!==index;p.setAttribute('role','tabpanel');if(i===index&&animate&&!this.motion.matches&&!this.classList.contains('v9b-journey--mobile-tabs'))this.addAnimation(p.animate([{opacity:.2,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:360,easing:'ease-out'}));});}disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-biz-system"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-v9-biz-system')){customElements.define('tl-v9-biz-system',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.buttons=[...this.querySelectorAll('[data-v9-tab]')];this.panels=[...this.querySelectorAll('[data-v9-panel]')];const tabs=this.querySelector('[data-v9-tabs]');if(tabs&&this.buttons.length){tabs.hidden=false;tabs.setAttribute('role','tablist');this.buttons.forEach((button,i)=>{button.setAttribute('role','tab');button.addEventListener('click',()=>this.select(i),{signal:this.abort.signal});button.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(i+1)%this.buttons.length;else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(i-1+this.buttons.length)%this.buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.buttons.length-1;else return;event.preventDefault();this.select(next);this.buttons[next].focus();},{signal:this.abort.signal});});this.select(0,false);}if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){this.observer.unobserve(entry.target);if(!this.motion.matches)this.animations.push(entry.target.animate([{opacity:.4,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'}));}}),{threshold:.15});this.querySelectorAll('[data-v9-reveal]').forEach(e=>this.observer.observe(e));}this.motion.addEventListener('change',()=>{if(this.motion.matches)this.animations.forEach(a=>a.cancel());},{signal:this.abort.signal});}select(index,animate=true){this.dataset.active=String(index+1);this.buttons.forEach((b,i)=>{b.setAttribute('aria-selected',String(i===index));b.tabIndex=i===index?0:-1;});this.panels.forEach((p,i)=>{p.hidden=i!==index;p.setAttribute('role','tabpanel');if(i===index&&animate&&!this.motion.matches)this.animations.push(p.animate([{opacity:.2,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:360,easing:'ease-out'}));});}disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-biz-workbench"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-v9-biz-workbench')) {
 customElements.define('tl-v9-biz-workbench', class extends HTMLElement {
  connectedCallback() {
   if (this.abort && !this.abort.signal.aborted) return;
   this.abort = new AbortController();
   const options = {signal: this.abort.signal};
   this.buttons = [...this.querySelectorAll('[data-v9-tab]')];
   this.panels = [...this.querySelectorAll('[data-v9-panel]')];
   const tabs = this.querySelector('[data-v9-tabs]');
   if (!tabs || !this.buttons.length || this.buttons.length !== this.panels.length) return;
   tabs.hidden = false;
   tabs.setAttribute('role', 'tablist');
   this.buttons.forEach((button, index) => {
    button.setAttribute('role', 'tab');
    button.addEventListener('click', () => this.select(index), options);
    button.addEventListener('keydown', event => {
     let next = index;
     if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.buttons.length;
     else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.buttons.length) % this.buttons.length;
     else if (event.key === 'Home') next = 0;
     else if (event.key === 'End') next = this.buttons.length - 1;
     else return;
     event.preventDefault();
     this.select(next);
     this.buttons[next].focus();
    }, options);
   });
   const initial = this.buttons.findIndex(button => button.getAttribute('aria-selected') === 'true');
   this.active = null;
   this.select(initial < 0 ? 0 : initial);
  }
  select(index) {
   if (!Number.isInteger(index) || !this.panels[index] || this.active === index) return;
   this.active = index;
   this.dataset.active = String(index + 1);
   this.buttons.forEach((button, i) => {
    button.setAttribute('aria-selected', String(i === index));
    button.tabIndex = i === index ? 0 : -1;
   });
   this.panels.forEach((panel, i) => {
    panel.hidden = i !== index;
    panel.setAttribute('role', 'tabpanel');
   });
  }
  disconnectedCallback() { this.abort?.abort(); }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-cat-stage"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-v9-cat-stage')) {
  customElements.define('tl-v9-cat-stage', class extends HTMLElement {
    connectedCallback() {
      if (this.observer || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.inview = 'true';
        this.observer.disconnect();
      }, { threshold: .08 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.observer = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-guide-check"] && !Shopify.designMode) return;
  try {
    
function v9GuideChecks(root=document){root.querySelectorAll('[data-v9g-check]').forEach(section=>{
  if(section.dataset.bound)return;section.dataset.bound='true';
  const progress=section.querySelector('[data-v9g-progress]');progress.hidden=false;
  const inputs=[...section.querySelectorAll('input[type=checkbox]')], link=section.querySelector('[data-check-quote]');
  const baseHref=link?.href;
  function update(){
    const selected=inputs.filter(input=>input.checked),count=selected.length;
    section.querySelector('[data-v9g-count]').textContent=count;
    section.querySelector('[data-v9g-bar]').style.width=(inputs.length?count/inputs.length*100:0)+'%';
    if(link){const target=new URL(baseHref);if(target.origin===location.origin && target.pathname.endsWith('/pages/request-quote')){
      const heading=section.querySelector('h2').textContent.trim(),labels=selected.map(input=>input.closest('.v9g-check__item').querySelector('label').textContent.trim());
      target.searchParams.set('brief',heading+(labels.length?'\n'+section.dataset.checkSummary+'\n'+labels.map(label=>'• '+label).join('\n'):''));
      link.href=target.pathname+target.search+target.hash;
    }}
  }
  inputs.forEach(input=>input.addEventListener('change',update));update();
});}v9GuideChecks();document.addEventListener('shopify:section:load',event=>v9GuideChecks(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-guide-cost"] && !Shopify.designMode) return;
  try {
    
function v9GuideCosts(root=document){root.querySelectorAll('[data-v9g-cost]').forEach(section=>{if(section.dataset.bound)return;section.dataset.bound='true';section.querySelector('[data-v9g-inputs]').hidden=false;const fields=Object.fromEntries([...section.querySelectorAll('input')].map(input=>[input.name,input]));let formatter;try{formatter=new Intl.NumberFormat(document.documentElement.lang||'ru',{maximumFractionDigits:1});}catch{formatter=new Intl.NumberFormat('ru',{maximumFractionDigits:1});}function update(){const heat=fields.heat.valueAsNumber,energy=fields.energy.valueAsNumber,efficiency=fields.efficiency.valueAsNumber/100,tariff=fields.tariff.valueAsNumber;const valid=['heat','energy','efficiency'].every(name=>fields[name].value!==''&&fields[name].checkValidity())&&[heat,energy,efficiency].every(value=>Number.isFinite(value)&&value>0);section.querySelector('[data-v9g-error]').hidden=valid;const volume=valid?heat/(energy*efficiency):NaN;section.querySelector('[data-v9g-volume]').textContent=Number.isFinite(volume)?formatter.format(volume):'—';section.querySelector('[data-v9g-cost-value]').textContent=Number.isFinite(volume)&&Number.isFinite(tariff)&&fields.tariff.checkValidity()?formatter.format(volume*tariff):'—';}Object.values(fields).forEach(input=>input.addEventListener('input',update));update();});}v9GuideCosts();document.addEventListener('shopify:section:load',event=>v9GuideCosts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-guide-cover"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-guide-opening'))customElements.define('tl-guide-opening',class extends HTMLElement{
  connectedCallback(){
    if(this.abort&&!this.abort.signal.aborted)return;
    const stage=this.querySelector('[data-guide-modes]');if(!stage)return;
    this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];
    this.buttons=[...stage.querySelectorAll('[data-guide-tab]')];this.panels=[...stage.querySelectorAll('[data-guide-panel]')];
    const tabs=stage.querySelector('[data-guide-tabs]');if(!tabs||!this.buttons.length)return;
    tabs.hidden=false;tabs.setAttribute('role','tablist');
    this.buttons.forEach((button,index)=>{
      button.setAttribute('role','tab');
      button.addEventListener('click',()=>this.select(index),{signal:this.abort.signal});
      button.addEventListener('keydown',event=>{
        const keys=['ArrowLeft','ArrowRight','Home','End'];if(!keys.includes(event.key))return;
        event.preventDefault();
        const next=event.key==='Home'?0:event.key==='End'?this.buttons.length-1:(index+(event.key==='ArrowRight'?1:-1)+this.buttons.length)%this.buttons.length;
        this.select(next);this.buttons[next].focus();
      },{signal:this.abort.signal});
    });
    this.select(0,false);
    this.motion.addEventListener('change',()=>{if(this.motion.matches)this.cancelAnimation();},{signal:this.abort.signal});
  }
  cancelAnimation(){this.animations?.forEach(animation=>animation.cancel());this.animations=[];}
  select(index,animate=true){
    this.cancelAnimation();
    this.buttons.forEach((button,i)=>{button.setAttribute('aria-selected',String(i===index));button.tabIndex=i===index?0:-1;});
    this.panels.forEach((panel,i)=>{panel.hidden=i!==index;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',this.buttons[i].id);});
    const panel=this.panels[index];
    if(animate&&!this.motion.matches&&panel?.animate){
      const animation=panel.animate([{opacity:.5,transform:'translateY(6px)'},{opacity:1,transform:'translateY(0)'}],{duration:220,easing:'ease-out'});
      this.animations=[animation];
      animation.addEventListener('finish',()=>{this.animations=this.animations.filter(current=>current!==animation);},{once:true});
    }
  }
  disconnectedCallback(){this.abort?.abort();this.cancelAnimation();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-guide-mode"] && !Shopify.designMode) return;
  try {
    
function v9GuideModes(root=document){root.querySelectorAll('div[data-v9g-mode]').forEach(section=>{if(section.dataset.bound)return;section.dataset.bound='true';section.querySelector('[data-v9g-mode-buttons]').hidden=false;const buttons=[...section.querySelectorAll('button[data-v9g-mode]')];function show(mode){section.querySelector('.v9g-mode__drawing').dataset.season=mode;buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.v9gMode===mode)));section.querySelectorAll('[data-v9g-panel]').forEach(panel=>panel.hidden=panel.dataset.v9gPanel!==mode);}buttons.forEach(button=>button.addEventListener('click',()=>show(button.dataset.v9gMode)));show('summer');});}v9GuideModes();document.addEventListener('shopify:section:load',event=>v9GuideModes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-intake-paths"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('tl-intake-paths'))customElements.define('tl-intake-paths',class extends HTMLElement{
    connectedCallback(){this.handle=e=>{const link=e.target.closest('[data-intake-type]');if(!link)return;const target=document.querySelector('#request-form');const select=target?.querySelector('select[name="contact[request_type]"]');if(!select)return;const value=link.dataset.intakeType;if(!Array.from(select.options).some(o=>o.value===value))return;e.preventDefault();select.value=value;select.dispatchEvent(new Event('change',{bubbles:true}));this.querySelectorAll('[data-intake-type]').forEach(a=>a.classList.toggle('is-selected',a===link));target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});select.focus({preventScroll:true})};this.addEventListener('click',this.handle)}
    disconnectedCallback(){this.removeEventListener('click',this.handle)}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-market-opening"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('tl-market-opening'))customElements.define('tl-market-opening',class extends HTMLElement{
    connectedCallback(){this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.stop=()=>{if(this.motion.matches)this.animations.forEach(a=>a.cancel())};this.motion.addEventListener('change',this.stop);if(!window.IntersectionObserver)return;this.observer=new IntersectionObserver(entries=>{if(!entries.some(e=>e.isIntersecting))return;this.observer.disconnect();if(this.motion.matches)return;this.querySelectorAll('.tl-market-opening__nodes li').forEach((el,i)=>{if(el.animate)this.animations.push(el.animate([{transform:'translateY(12px)'},{transform:'translateY(0)'}],{duration:420,delay:i*65,easing:'cubic-bezier(.2,.7,.2,1)'}))})},{threshold:.15});this.observer.observe(this)}
    disconnectedCallback(){this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());this.motion?.removeEventListener('change',this.stop)}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-wholesale-evidence"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-wholesale-evidence')) {
    customElements.define('tl-wholesale-evidence', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.checks = [...this.querySelectorAll('[data-wholesale-check]')];
        this.inquiry = this.querySelector('[data-wholesale-inquiry]');
        this.preview = this.querySelector('[data-wholesale-preview]');
        this.message = this.querySelector('[data-wholesale-message]');
        this.status = this.querySelector('[data-wholesale-status]');
        this.copy = this.querySelector('[data-wholesale-copy]');
        this.clear = this.querySelector('[data-wholesale-clear]');
        if (!this.message || !this.status || !this.copy || !this.clear) return;
        this.baseInquiry = this.inquiry ? this.inquiry.getAttribute('href') : '';
        if (!this.dataset.bootstrapped && !window.Shopify?.designMode) {
          this.querySelectorAll('.tl-wholesale-evidence__record').forEach((record, index) => { record.open = index === 0; });
        }
        this.dataset.bootstrapped = 'true';
        this.querySelectorAll('[data-wholesale-enhanced]').forEach(element => { element.hidden = false; });
        this.dataset.enhanced = 'true';
        this.addEventListener('change', event => {
          if (event.target.matches('[data-wholesale-check]')) this.updateSelection();
        }, { signal });
        this.clear.addEventListener('click', () => {
          this.checks.forEach(check => { check.checked = false; });
          this.updateSelection();
          this.checks[0]?.focus({ preventScroll: true });
        }, { signal });
        this.copy.addEventListener('click', async () => {
          const message = this.message.value;
          if (!message) return;
          try {
            await navigator.clipboard.writeText(message);
            if (this.isConnected && this.message.value === message) this.status.textContent = this.dataset.copied;
          } catch {
            if (!this.isConnected || this.message.value !== message) return;
            this.preview.open = true;
            this.message.focus({ preventScroll: true });
            this.message.select();
            this.status.textContent = this.dataset.copyManual;
          }
        }, { signal });
        if (this.inquiry) {
          const preventUnavailable = event => {
            if (event.type === 'auxclick' && event.button !== 1) return;
            if (this.inquiry.getAttribute('aria-disabled') === 'true') event.preventDefault();
          };
          this.inquiry.addEventListener('click', preventUnavailable, { signal });
          this.inquiry.addEventListener('auxclick', preventUnavailable, { signal });
        }
        window.addEventListener('pageshow', () => this.updateSelection(), { signal });
        this.updateSelection();
      }
      updateSelection() {
        const selected = this.checks.filter(check => check.checked);
        this.checks.forEach(check => { check.closest('[data-wholesale-item]').classList.toggle('is-selected', check.checked); });
        this.querySelector('[data-wholesale-count]').textContent = String(selected.length);
        this.clear.disabled = selected.length === 0;
        this.copy.disabled = selected.length === 0;
        this.preview.hidden = selected.length === 0;
        this.status.textContent = '';
        const text = element => element?.textContent.trim() || '';
        const lines = selected.map((check, index) => {
          const item = check.closest('[data-wholesale-item]');
          return [`${index + 1}. ${text(item.querySelector('[data-wholesale-item-title]'))}`, `${text(item.querySelector('[data-wholesale-input-label]'))}: ${text(item.querySelector('[data-wholesale-item-input]'))}`, `${text(item.querySelector('[data-wholesale-detail-label]'))}: ${text(item.querySelector('[data-wholesale-item-detail]'))}`].join('\n');
        });
        const message = selected.length ? [text(this.querySelector('[data-wholesale-title]')), ...lines, this.dataset.briefNote].filter(Boolean).join('\n\n') : '';
        this.message.value = message;
        if (!this.inquiry || !this.baseInquiry) return;
        const target = new URL(this.baseInquiry, location.href);
        this.inquiry.removeAttribute('aria-disabled');
        if (target.origin !== location.origin || !/\/pages\/request-quote\/?$/.test(target.pathname)) {
          this.inquiry.setAttribute('href', this.baseInquiry);
          return;
        }
        target.searchParams.set('source_page', location.pathname);
        if (message.length > 4000) {
          this.inquiry.setAttribute('aria-disabled', 'true');
          this.inquiry.removeAttribute('href');
          this.status.textContent = this.dataset.tooLong;
          return;
        }
        if (message) target.searchParams.set('brief', message);
        else target.searchParams.delete('brief');
        this.inquiry.setAttribute('href', target.pathname + target.search + target.hash);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
